// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import botImage from "../../assets/images/chatbot_icon.png";
// import NetworkErrorModal from "./NetworkErrorModal";
// import EndChatModal from "./EndChatModal";

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// /*
//  * ============================================================
//  * GET CURRENT TIME
//  * ============================================================
//  */

// const getTime = () => {
//     return new Date().toLocaleTimeString([], {
//         hour: "2-digit",
//         minute: "2-digit",
//     });
// };

// /*
//  * ============================================================
//  * GET OPTION TEXT
//  * ============================================================
//  */

// const getOptionText = (optionItem) => {

//     if (typeof optionItem === "string") {
//         return optionItem;
//     }

//     return (
//         optionItem?.option_name ||
//         optionItem?.question ||
//         optionItem?.title ||
//         optionItem?.option_text ||
//         ""
//     );
// };

// /*
//  * ============================================================
//  * GET OPTION ID
//  * ============================================================
//  */

// const getOptionId = (optionItem) => {

//     if (!optionItem || typeof optionItem === "string") {
//         return null;
//     }

//     return (
//         optionItem.content_id ||
//         optionItem.option_id ||
//         optionItem.faq_id ||
//         optionItem.id ||
//         null
//     );
// };

// /*
//  * ============================================================
//  * MESSAGE CONTENT RENDERER
//  * ============================================================
//  *
//  * Supports:
//  *
//  * **Bold Text**
//  *
//  * * Bullet
//  * - Bullet
//  *
//  * [Book Demo](https://swiftintelli.com/demo)
//  *
//  * https://swiftintelli.com/demo
//  *
//  * contact@swiftintelli.com
//  *
//  * +91 9391966251
//  *
//  * Normal text
//  *
//  * Line breaks
//  *
//  * ============================================================
//  */

// /*
//  * ============================================================
//  * RENDER INLINE CONTENT
//  * ============================================================
//  */

// const renderInlineContent = (text, lineIndex) => {

//     if (!text) {
//         return null;
//     }

//     /*
//      * ========================================================
//      * COMBINED REGEX
//      * ========================================================
//      *
//      * Group 1/2:
//      * **Bold Text**
//      *
//      * Group 3/4/5:
//      * [Book Demo](https://...)
//      *
//      * Group 6:
//      * Normal https://...
//      *
//      * Group 7:
//      * Email
//      *
//      * Group 8:
//      * Phone
//      *
//      * ========================================================
//      */

//     const combinedRegex =
//         /(\*\*([^*]+)\*\*)|(\[([^\]]+)\]\((https?:\/\/[^\s)]+)\))|(https?:\/\/[^\s<]+)|([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})|(\+?\d[\d\s().-]{7,}\d)/g;

//     const parts = [];

//     let lastIndex = 0;
//     let match;

//     let partIndex = 0;

//     while ((match = combinedRegex.exec(text)) !== null) {

//         /*
//          * ====================================================
//          * NORMAL TEXT BEFORE MATCH
//          * ====================================================
//          */

//         if (match.index > lastIndex) {

//             parts.push(
//                 <React.Fragment
//                     key={`text-${lineIndex}-${partIndex++}`}
//                 >
//                     {text.substring(
//                         lastIndex,
//                         match.index
//                     )}
//                 </React.Fragment>
//             );
//         }

//         /*
//          * ====================================================
//          * BOLD TEXT
//          *
//          * **Official Social Media Links**
//          * ====================================================
//          */

//         if (match[1]) {

//             parts.push(
//                 <strong
//                     key={`bold-${lineIndex}-${partIndex++}`}
//                 >
//                     {match[2]}
//                 </strong>
//             );
//         }

//         /*
//          * ====================================================
//          * MARKDOWN LINK
//          *
//          * [YouTube](https://youtube.com/...)
//          * ====================================================
//          */

//         else if (match[3]) {

//             parts.push(
//                 <a
//                     key={`markdown-link-${lineIndex}-${partIndex++}`}
//                     href={match[5]}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="chat-content-link"
//                 >
//                     {match[4]}
//                 </a>
//             );
//         }

//         /*
//          * ====================================================
//          * NORMAL URL
//          * ====================================================
//          */

//         else if (match[6]) {

//             const rawUrl = match[6];

//             /*
//              * Remove trailing punctuation from URL.
//              */

//             const trailingMatch =
//                 rawUrl.match(/[.,!?;:]+$/);

//             const cleanUrl =
//                 trailingMatch
//                     ? rawUrl.substring(
//                         0,
//                         rawUrl.length -
//                         trailingMatch[0].length
//                     )
//                     : rawUrl;

//             const trailingText =
//                 trailingMatch
//                     ? trailingMatch[0]
//                     : "";

//             parts.push(
//                 <a
//                     key={`url-${lineIndex}-${partIndex++}`}
//                     href={cleanUrl}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="chat-content-link"
//                 >
//                     {cleanUrl}
//                 </a>
//             );

//             /*
//              * Keep punctuation outside link.
//              */

//             if (trailingText) {

//                 parts.push(
//                     <React.Fragment
//                         key={`punctuation-${lineIndex}-${partIndex++}`}
//                     >
//                         {trailingText}
//                     </React.Fragment>
//                 );
//             }
//         }

//         /*
//          * ====================================================
//          * EMAIL ADDRESS
//          * ====================================================
//          */

//         else if (match[7]) {

//             const emailAddress = match[7];

//             parts.push(
//                 <a
//                     key={`email-${lineIndex}-${partIndex++}`}
//                     href={`mailto:${emailAddress}`}
//                     className="chat-content-link chat-email-link"
//                 >
//                     {emailAddress}
//                 </a>
//             );
//         }

//         /*
//          * ====================================================
//          * PHONE NUMBER
//          * ====================================================
//          */

//         else if (match[8]) {

//             const phoneNumber = match[8];

//             /*
//              * Remove spaces, brackets,
//              * hyphens and dots.
//              */

//             const cleanPhoneNumber =
//                 phoneNumber.replace(
//                     /[\s().-]/g,
//                     ""
//                 );

//             parts.push(
//                 <a
//                     key={`phone-${lineIndex}-${partIndex++}`}
//                     href={`tel:${cleanPhoneNumber}`}
//                     className="chat-content-link chat-phone-link"
//                 >
//                     {phoneNumber}
//                 </a>
//             );
//         }

//         lastIndex =
//             combinedRegex.lastIndex;
//     }

//     /*
//      * ========================================================
//      * REMAINING TEXT
//      * ========================================================
//      */

//     if (lastIndex < text.length) {

//         parts.push(
//             <React.Fragment
//                 key={`remaining-${lineIndex}-${partIndex++}`}
//             >
//                 {text.substring(lastIndex)}
//             </React.Fragment>
//         );
//     }

//     /*
//      * ========================================================
//      * NO SPECIAL CONTENT
//      * ========================================================
//      */

//     if (parts.length === 0) {
//         return text;
//     }

//     return parts;
// };

// /*
//  * ============================================================
//  * RENDER MESSAGE CONTENT
//  * ============================================================
//  */

// const renderMessageContent = (text) => {

//     if (!text) {
//         return null;
//     }

//     /*
//      * Convert backend content into lines.
//      */

//     const lines =
//         String(text).split(/\r?\n/);

//     return (
//         <div className="chat-message-content-rendered">

//             {lines.map((line, index) => {

//                 const trimmedLine =
//                     line.trim();

//                 /*
//                  * ====================================================
//                  * EMPTY LINE
//                  * ====================================================
//                  */

//                 if (!trimmedLine) {

//                     return (
//                         <div
//                             key={`empty-${index}`}
//                             className="chat-content-empty-line"
//                         />
//                     );
//                 }

//                 /*
//                  * ====================================================
//                  * BULLET POINT
//                  *
//                  * Supports:
//                  *
//                  * * YouTube
//                  * * Instagram
//                  *
//                  * - YouTube
//                  * - Instagram
//                  *
//                  * The * character will NOT be displayed.
//                  * ====================================================
//                  */

//                 if (
//                     trimmedLine.startsWith("* ") ||
//                     trimmedLine.startsWith("- ")
//                 ) {

//                     const bulletText =
//                         trimmedLine
//                             .substring(2)
//                             .trim();

//                     return (
//                         <div
//                             key={`bullet-${index}`}
//                             className="chat-content-bullet"
//                         >

//                             <span className="chat-bullet-dot">
//                                 •
//                             </span>

//                             <span>
//                                 {renderInlineContent(
//                                     bulletText,
//                                     index
//                                 )}
//                             </span>

//                         </div>
//                     );
//                 }

//                 /*
//                  * ====================================================
//                  * NORMAL LINE
//                  * ====================================================
//                  */

//                 return (
//                     <div
//                         key={`line-${index}`}
//                         className="chat-content-line"
//                     >
//                         {renderInlineContent(
//                             line,
//                             index
//                         )}
//                     </div>
//                 );
//             })}

//         </div>
//     );
// };

// /*
//  * ============================================================
//  * CHAT SCREEN
//  * ============================================================
//  */

// const ChatScreen = ({
//     onClose,
//     user,
//     setScreen,
//     pendingMessage,
//     setPendingMessage
// }) => {

//     /*
//      * ============================================================
//      * SESSION ID
//      * ============================================================
//      */

//     const [sessionId] = useState(() => {

//         return user?.email
//             ? `session_${btoa(user.email).replace(/=/g, "")}`
//             : `session_${Date.now()}`;
//     });

//     /*
//      * ============================================================
//      * MESSAGES
//      * ============================================================
//      */

//     const [messages, setMessages] = useState(() => {

//         try {

//             const savedMessages =
//                 localStorage.getItem(
//                     "chatbot_messages"
//                 );

//             if (savedMessages) {

//                 return JSON.parse(
//                     savedMessages
//                 );
//             }

//         } catch (error) {

//             console.error(
//                 "Could not parse saved messages",
//                 error
//             );
//         }

//         return [
//             {
//                 id: 1,
//                 sender: "bot",
//                 text:
//                     `Hello ${user?.name || "there"} 👋`,
//                 timestamp: getTime(),
//             },
//             {
//                 id: 2,
//                 sender: "bot",
//                 text:
//                     "How can I help you today?",
//                 timestamp: getTime(),
//             },
//         ];
//     });

//     /*
//      * ============================================================
//      * INPUT MESSAGE
//      * ============================================================
//      */

//     const [inputMessage, setInputMessage] =
//         useState("");

//     /*
//      * ============================================================
//      * TYPING
//      * ============================================================
//      */

//     const [isTyping, setIsTyping] =
//         useState(false);

//     /*
//      * ============================================================
//      * DYNAMIC OPTIONS
//      * ============================================================
//      */

//     const [dynamicOptions, setDynamicOptions] =
//         useState(() => {

//             try {

//                 const saved =
//                     localStorage.getItem(
//                         "chatbot_dynamicOptions"
//                     );

//                 if (saved) {

//                     return JSON.parse(
//                         saved
//                     );
//                 }

//             } catch (error) {

//                 console.error(
//                     "Could not parse dynamic options",
//                     error
//                 );
//             }

//             return [];
//         });

//     /*
//      * ============================================================
//      * FINAL STATE
//      * ============================================================
//      */

//     const [isFinal, setIsFinal] =
//         useState(() => {

//             try {

//                 return (
//                     localStorage.getItem(
//                         "chatbot_isFinal"
//                     ) === "true"
//                 );

//             } catch (error) {

//                 return false;
//             }
//         });

//     /*
//      * ============================================================
//      * MODALS
//      * ============================================================
//      */

//     const [showNetworkError, setShowNetworkError] =
//         useState(false);

//     const [showEndChatModal, setShowEndChatModal] =
//         useState(false);

//     /*
//      * ============================================================
//      * COURSE SUGGESTION
//      * ============================================================
//      */

//     const [courseSuggestion, setCourseSuggestion] =
//         useState("");

//     const [isSubmittingSuggestion, setIsSubmittingSuggestion] =
//         useState(false);

//     const [showCourseSuggestionForm, setShowCourseSuggestionForm] =
//         useState(false);

//     /*
//      * ============================================================
//      * REFS
//      * ============================================================
//      */

//     const chatBodyRef =
//         useRef(null);

//     const pendingProcessedRef =
//         useRef(false);

//     /*
//      * ============================================================
//      * SAVE DYNAMIC OPTIONS
//      * ============================================================
//      */

//     useEffect(() => {

//         try {

//             localStorage.setItem(
//                 "chatbot_dynamicOptions",
//                 JSON.stringify(
//                     dynamicOptions
//                 )
//             );

//         } catch (error) {

//             console.error(
//                 "Could not save dynamic options",
//                 error
//             );
//         }

//     }, [dynamicOptions]);

//     /*
//      * ============================================================
//      * SAVE FINAL STATE
//      * ============================================================
//      */

//     useEffect(() => {

//         try {

//             localStorage.setItem(
//                 "chatbot_isFinal",
//                 String(isFinal)
//             );

//         } catch (error) {

//             console.error(
//                 "Could not save final state",
//                 error
//             );
//         }

//     }, [isFinal]);

//     /*
//      * ============================================================
//      * EXTRACT BACKEND DATA
//      * ============================================================
//      */

//     const extractBackendData = (
//         responseData
//     ) => {

//         const data =
//             responseData?.data || {};

//         const answer =
//             responseData?.answer ??
//             data?.answer ??
//             data?.content ??
//             responseData?.content ??
//             "";

//         const followups =
//             Array.isArray(
//                 responseData?.followups
//             )
//                 ? responseData.followups
//                 : Array.isArray(
//                     data?.followups
//                 )
//                     ? data.followups
//                     : [];

//         const nextQuestions =
//             Array.isArray(
//                 responseData?.next_questions
//             )
//                 ? responseData.next_questions
//                 : Array.isArray(
//                     data?.next_questions
//                 )
//                     ? data.next_questions
//                     : [];

//         const final =
//             responseData?.is_final === true ||
//             data?.is_final === true;

//         return {
//             answer,
//             followups,
//             nextQuestions,
//             isFinal: final,
//         };
//     };

//     /*
//      * ============================================================
//      * COURSE SUGGESTION SUBMIT
//      * ============================================================
//      *
//      * API:
//      *
//      * POST /suggest-course
//      *
//      * Request body:
//      *
//      * {
//      *     "suggested_course": "string",
//      *     "session_id": "string",
//      *     "created_by_ip": "string"
//      * }
//      *
//      * ============================================================
//      */

//     const handleCourseSuggestionSubmit = async () => {

//         const courseName =
//             courseSuggestion.trim();

//         /*
//          * Do not submit empty value.
//          */

//         if (!courseName) {
//             return;
//         }

//         /*
//          * Maximum 150 characters.
//          */

//         if (courseName.length > 150) {
//             return;
//         }

//         setIsSubmittingSuggestion(true);

//         /*
//          * ========================================================
//          * SHOW USER MESSAGE
//          * ========================================================
//          */

//         setMessages((prev) => [

//             ...prev,

//             {
//                 id: Date.now(),
//                 sender: "user",
//                 text: courseName,
//                 timestamp: getTime(),
//             },

//         ]);

//         /*
//          * Hide form after submit.
//          */

//         setShowCourseSuggestionForm(false);

//         /*
//          * Clear input.
//          */

//         setCourseSuggestion("");

//         try {

//             /*
//              * ====================================================
//              * API REQUEST
//              * ====================================================
//              */

//             const response =
//                 await axios.post(
//                     `${API_BASE_URL}/suggest-course`,
//                     {
//                         suggested_course:
//                             courseName,

//                         session_id:
//                             sessionId,

//                         /*
//                          * The backend schema requires
//                          * created_by_ip.
//                          *
//                          * If your backend automatically
//                          * detects the actual client IP,
//                          * you can later remove this field
//                          * from the Pydantic schema.
//                          */

//                         created_by_ip:
//                             "chatbot-web",
//                     }
//                 );

//             console.log(
//                 "Course suggestion response:",
//                 response.data
//             );

//             /*
//              * ====================================================
//              * EXTRACT RESPONSE
//              * ====================================================
//              */

//             const {
//                 answer,
//                 followups,
//                 nextQuestions,
//                 isFinal:
//                     responseIsFinal
//             } =
//                 extractBackendData(
//                     response.data
//                 );

//             /*
//              * ====================================================
//              * SUCCESS MESSAGE
//              * ====================================================
//              *
//              * If backend returns content_id 15 response,
//              * it will be rendered here.
//              * ====================================================
//              */

//             setMessages((prev) => [

//                 ...prev,

//                 {
//                     id: Date.now(),

//                     sender: "bot",

//                     text:
//                         answer ||
//                         "Thank you for your valuable suggestion! We appreciate your feedback.",

//                     timestamp:
//                         getTime(),
//                 },

//             ]);

//             /*
//              * ====================================================
//              * FOLLOW-UP OPTIONS
//              * ====================================================
//              */

//             if (
//                 followups.length > 0 ||
//                 nextQuestions.length > 0
//             ) {

//                 setDynamicOptions(

//                     followups.length > 0
//                         ? followups
//                         : nextQuestions

//                 );

//             } else {

//                 setDynamicOptions([]);
//             }

//             /*
//              * ====================================================
//              * FINAL STATE
//              * ====================================================
//              */

//             setIsFinal(responseIsFinal);

//         } catch (error) {

//             console.error(
//                 "Course suggestion submission error:",
//                 error
//             );

//             /*
//              * ====================================================
//              * SHOW ERROR
//              * ====================================================
//              */

//             setMessages((prev) => [

//                 ...prev,

//                 {
//                     id: Date.now(),

//                     sender: "bot",

//                     text:
//                         error?.response?.data?.detail ||
//                         "We could not submit your course suggestion right now. Please try again later.",

//                     timestamp:
//                         getTime(),

//                     isError:
//                         true,
//                 },

//             ]);

//             setDynamicOptions([]);

//             setIsFinal(false);

//         } finally {

//             setIsSubmittingSuggestion(false);
//         }
//     };

//     /*
//      * ============================================================
//      * HANDLE OPTION CLICK
//      * ============================================================
//      */

//     const handleOptionClick = async (
//         optionItem,
//         fallbackFollowUps = []
//     ) => {

//         const optionText =
//             getOptionText(optionItem);

//         const targetOptionId =
//             getOptionId(optionItem);

//         if (!optionText) {
//             return;
//         }

//         /*
//          * ========================================================
//          * SUGGEST A NEW COURSE
//          * ========================================================
//          *
//          * Database:
//          *
//          * content_id = 9
//          *
//          * title:
//          * Suggest a New Course
//          *
//          * ========================================================
//          */

//         if (
//             Number(targetOptionId) === 9 ||
//             optionText === "Suggest a New Course"
//         ) {

//             /*
//              * Add user selection to chat.
//              */

//             setMessages((prev) => [

//                 ...prev,

//                 {
//                     id: Date.now(),
//                     sender: "user",
//                     text: optionText,
//                     timestamp: getTime(),
//                 },

//             ]);

//             setDynamicOptions([]);

//             setIsFinal(false);

//             setIsTyping(true);

//             /*
//              * Small delay so the chatbot feels natural.
//              */

//             setTimeout(() => {

//                 setMessages((prev) => [

//                     ...prev,

//                     {
//                         id: Date.now(),
//                         sender: "bot",
//                         text:
//                             `Could not find the course you were looking for?

// Interested in a course that is not listed? Let us know!

// Stay tuned with us for upcoming courses. We are continuously expanding our course catalog based on industry trends and learner demand.

// Please enter the course you would like SwiftIntelli to offer.`,
//                         timestamp: getTime(),
//                     },

//                 ]);

//                 /*
//                  * Show course input.
//                  */

//                 setShowCourseSuggestionForm(true);

//                 setIsTyping(false);

//             }, 400);

//             return;
//         }

//         /*
//          * ========================================================
//          * NORMAL USER OPTION MESSAGE
//          * ========================================================
//          */

//         setMessages((prev) => {

//             const alreadyPushed =
//                 prev.some(
//                     (message) =>
//                         message.sender ===
//                             "user" &&
//                         message.text ===
//                             optionText &&
//                         Date.now() -
//                             message.id <
//                             100
//                 );

//             if (alreadyPushed) {
//                 return prev;
//             }

//             return [

//                 ...prev,

//                 {
//                     id: Date.now(),
//                     sender: "user",
//                     text: optionText,
//                     timestamp: getTime(),
//                 },

//             ];
//         });

//         /*
//          * ========================================================
//          * OTHERS
//          * ========================================================
//          */

//         if (optionText === "Others...") {

//             setIsFinal(false);

//             setDynamicOptions([]);

//             setIsTyping(true);

//             setTimeout(() => {

//                 setMessages((prev) => [

//                     ...prev,

//                     {
//                         id: Date.now(),
//                         sender: "bot",
//                         text:
//                             "Please type your specific query below!",
//                         timestamp: getTime(),
//                     },

//                 ]);

//                 setIsTyping(false);

//             }, 400);

//             return;
//         }

//         /*
//          * ========================================================
//          * CUSTOM CHAT
//          * ========================================================
//          */

//         if (!targetOptionId) {

//             await handleCustomChat(
//                 optionText
//             );

//             return;
//         }

//         setIsTyping(true);

//         try {

//             const isFaq =
//                 optionItem?.question !==
//                     undefined ||
//                 optionItem?.title !==
//                     undefined ||
//                 optionItem?.faq_id !==
//                     undefined ||
//                 optionItem?.content_id !==
//                     undefined;

//             const endpointUrl =
//                 isFaq
//                     ? `${API_BASE_URL}/faq-answer/${targetOptionId}`
//                     : `${API_BASE_URL}/sub-option-answer/${targetOptionId}`;

//             console.log(
//                 "Chatbot request:",
//                 endpointUrl
//             );

//             const response =
//                 await axios.get(
//                     endpointUrl
//                 );

//             console.log(
//                 "Chatbot response:",
//                 response.data
//             );

//             if (response.status !== 200) {

//                 throw new Error(
//                     "Unexpected response status"
//                 );
//             }

//             const {
//                 answer,
//                 followups,
//                 nextQuestions,
//                 isFinal:
//                     responseIsFinal
//             } =
//                 extractBackendData(
//                     response.data
//                 );

//             const answerContent =
//                 answer ||
//                 "Here is the information you requested.";

//             let optionsToShow = [];

//             if (followups.length > 0) {

//                 optionsToShow =
//                     followups;

//             } else if (
//                 nextQuestions.length > 0
//             ) {

//                 optionsToShow =
//                     nextQuestions;

//             } else {

//                 optionsToShow =
//                     fallbackFollowUps ||
//                     [];
//             }

//             setMessages((prev) => [

//                 ...prev,

//                 {
//                     id: Date.now(),
//                     sender: "bot",
//                     text: answerContent,
//                     timestamp: getTime(),
//                 },

//             ]);

//             setDynamicOptions(
//                 optionsToShow
//             );

//             setIsFinal(
//                 responseIsFinal
//             );

//         } catch (error) {

//             console.error(
//                 "Database structural response retrieval error:",
//                 error
//             );

//             handleErrorFallback();

//         } finally {

//             setIsTyping(false);
//         }
//     };

//     /*
//      * ============================================================
//      * CUSTOM CHAT
//      * ============================================================
//      */

//     const handleCustomChat = async (
//         messageText
//     ) => {

//         setIsTyping(true);

//         try {

//             const response =
//                 await axios.post(
//                     `${API_BASE_URL}/chat`,
//                     {
//                         session_id:
//                             sessionId,

//                         message:
//                             messageText,
//                     }
//                 );

//             if (
//                 response.data &&
//                 response.data.success
//             ) {

//                 const {
//                     answer,
//                     followups,
//                     nextQuestions,
//                     isFinal:
//                         responseIsFinal
//                 } =
//                     extractBackendData(
//                         response.data
//                     );

//                 setMessages((prev) => [

//                     ...prev,

//                     {
//                         id:
//                             response.data.log_id ||
//                             Date.now(),

//                         sender:
//                             "bot",

//                         text:
//                             answer ||
//                             "Here is the information you requested.",

//                         timestamp:
//                             getTime(),
//                     },

//                 ]);

//                 if (
//                     followups.length > 0 ||
//                     nextQuestions.length > 0
//                 ) {

//                     setDynamicOptions(

//                         followups.length > 0
//                             ? followups
//                             : nextQuestions

//                     );

//                 } else {

//                     setDynamicOptions([]);
//                 }

//                 setIsFinal(
//                     responseIsFinal
//                 );

//             } else {

//                 throw new Error(
//                     response.data?.message ||
//                     "Chat request failed"
//                 );
//             }

//         } catch (error) {

//             console.error(
//                 "Chat engine communication error:",
//                 error
//             );

//             handleErrorFallback();

//         } finally {

//             setIsTyping(false);
//         }
//     };

//     /*
//      * ============================================================
//      * HANDLE FOLLOW-UP CLICK
//      * ============================================================
//      */

//     const handleFollowUpClick = (
//         optItem
//     ) => {

//         const optId =
//             getOptionId(optItem);

//         let remainingFollowUps;

//         if (optId !== null) {

//             remainingFollowUps =
//                 dynamicOptions.filter(
//                     (item) =>
//                         getOptionId(
//                             item
//                         ) !== optId
//                 );

//         } else {

//             const clickedText =
//                 getOptionText(
//                     optItem
//                 );

//             remainingFollowUps =
//                 dynamicOptions.filter(
//                     (item) =>
//                         getOptionText(
//                             item
//                         ) !==
//                         clickedText
//                 );
//         }

//         setDynamicOptions(
//             remainingFollowUps
//         );

//         setIsFinal(false);

//         handleOptionClick(
//             optItem,
//             remainingFollowUps
//         );
//     };

//     /*
//      * ============================================================
//      * ERROR FALLBACK
//      * ============================================================
//      */

//     const handleErrorFallback = () => {

//         setMessages((prev) => [

//             ...prev,

//             {
//                 id: Date.now(),
//                 sender: "bot",
//                 text:
//                     "Something went wrong. Please try again after sometime.",
//                 timestamp: getTime(),
//                 isError: true,
//             },

//         ]);

//         setDynamicOptions([]);

//         setIsFinal(false);

//         setShowNetworkError(true);
//     };

//     /*
//      * ============================================================
//      * END CHAT
//      * ============================================================
//      */

//     const handleEndChat = () => {

//         setShowEndChatModal(true);
//     };

//     const confirmEndChat = () => {

//         axios
//             .post(
//                 `${API_BASE_URL}/end-chat`,
//                 {
//                     session_id:
//                         sessionId,
//                 }
//             )
//             .catch((error) =>
//                 console.error(
//                     "Clean session termination failed:",
//                     error
//                 )
//             );

//         setShowEndChatModal(false);

//         localStorage.removeItem(
//             "chatbot_messages"
//         );

//         localStorage.removeItem(
//             "chatbot_dynamicOptions"
//         );

//         localStorage.removeItem(
//             "chatbot_isFinal"
//         );

//         setDynamicOptions([]);

//         setIsFinal(false);

//         setShowCourseSuggestionForm(false);

//         setCourseSuggestion("");

//         setScreen("welcome");
//     };

//     /*
//      * ============================================================
//      * RETRY NETWORK
//      * ============================================================
//      */

//     const handleRetryNetwork = () => {

//         setShowNetworkError(false);
//     };

//     /*
//      * ============================================================
//      * BACK TO WELCOME
//      * ============================================================
//      */

//     const handleBackToWelcome = () => {

//         setDynamicOptions([]);

//         setIsFinal(false);

//         setPendingMessage("");

//         setShowCourseSuggestionForm(false);

//         setCourseSuggestion("");

//         localStorage.removeItem(
//             "chatbot_messages"
//         );

//         localStorage.removeItem(
//             "chatbot_dynamicOptions"
//         );

//         localStorage.removeItem(
//             "chatbot_isFinal"
//         );

//         setScreen("welcome");
//     };

//     /*
//      * ============================================================
//      * PENDING MESSAGE
//      * ============================================================
//      */

//     useEffect(() => {

//         if (
//             pendingMessage &&
//             !pendingProcessedRef.current
//         ) {

//             pendingProcessedRef.current =
//                 true;

//             const messageToProcess =
//                 pendingMessage;

//             setDynamicOptions([]);

//             setIsFinal(false);

//             setPendingMessage("");

//             handleOptionClick(
//                 messageToProcess
//             );
//         }

//         if (!pendingMessage) {

//             pendingProcessedRef.current =
//                 false;
//         }

//     }, [pendingMessage]);

//     /*
//      * ============================================================
//      * SAVE MESSAGES
//      * ============================================================
//      */

//     useEffect(() => {

//         try {

//             localStorage.setItem(
//                 "chatbot_messages",
//                 JSON.stringify(messages)
//             );

//         } catch (error) {

//             console.error(
//                 "Could not save messages",
//                 error
//             );
//         }

//     }, [messages]);

//     /*
//      * ============================================================
//      * AUTO SCROLL
//      * ============================================================
//      */

//     useEffect(() => {

//         if (chatBodyRef.current) {

//             chatBodyRef.current.scrollTop =
//                 chatBodyRef.current.scrollHeight;
//         }

//     }, [
//         messages,
//         isTyping,
//         dynamicOptions,
//         showCourseSuggestionForm
//     ]);

//     /*
//      * ============================================================
//      * SEND MESSAGE
//      * ============================================================
//      */

//     const handleSendMessage = () => {

//         if (!inputMessage.trim()) {
//             return;
//         }

//         const userText =
//             inputMessage.trim();

//         setMessages((prev) => [

//             ...prev,

//             {
//                 id: Date.now(),
//                 sender: "user",
//                 text: userText,
//                 timestamp: getTime(),
//             },

//         ]);

//         setInputMessage("");

//         setDynamicOptions([]);

//         setIsFinal(false);

//         handleCustomChat(
//             userText
//         );
//     };

//     /*
//      * ============================================================
//      * DYNAMIC OPTIONS
//      * ============================================================
//      */

//     const hasDynamicOptions =
//         dynamicOptions.length > 0;

//     const showBackToWelcome =
//         isFinal &&
//         !isTyping &&
//         !hasDynamicOptions &&
//         !showCourseSuggestionForm;

//     /*
//      * ============================================================
//      * UI
//      * ============================================================
//      */

//     return (

//         <div className="chat-screen-container">

//             {/* ==================================================
//                 HEADER
//             ================================================== */}

//             <div className="chat-header">

//                 <div className="chat-header-left">

//                     <div className="chat-avatar-wrapper">

//                         <img
//                             src={botImage}
//                             alt="Bot"
//                             className="chat-avatar-img"
//                         />

//                     </div>

//                     <div>

//                         <h4 className="chat-title">
//                             IntelliBot
//                         </h4>

//                         <div className="chat-status">
//                             Online
//                         </div>

//                     </div>

//                 </div>

//                 <button
//                     className="end-chat-btn"
//                     onClick={
//                         handleEndChat
//                     }
//                 >
//                     End Chat
//                 </button>

//             </div>

//             {/* ==================================================
//                 CHAT BODY
//             ================================================== */}

//             <div
//                 className="chat-body"
//                 ref={chatBodyRef}
//             >

//                 <div className="chat-messages">

//                     {messages.map(
//                         (message, idx) => {

//                             /*
//                              * ==================================================
//                              * USER MESSAGE
//                              * ==================================================
//                              */

//                             if (
//                                 message.sender ===
//                                 "user"
//                             ) {

//                                 return (

//                                     <div
//                                         key={
//                                             message.id
//                                         }
//                                         className="message user-message"
//                                     >

//                                         <div className="message-text">

//                                             {
//                                                 message.text
//                                             }

//                                         </div>

//                                         <div className="message-time">

//                                             {
//                                                 message.timestamp
//                                             }

//                                         </div>

//                                     </div>
//                                 );
//                             }

//                             /*
//                              * ==================================================
//                              * BOT MESSAGE
//                              * ==================================================
//                              */

//                             const isLatestBotMessage =
//                                 idx ===
//                                 messages.length -
//                                 1;

//                             const showCurrentFollowUps =
//                                 isLatestBotMessage &&
//                                 hasDynamicOptions;

//                             return (

//                                 <React.Fragment
//                                     key={
//                                         message.id
//                                     }
//                                 >

//                                     <div
//                                         className={`message bot-message ${
//                                             message.isError
//                                                 ? "error-bubble"
//                                                 : ""
//                                         }`}
//                                     >

//                                         <div className="bot-avatar-small">

//                                             <img
//                                                 src={
//                                                     botImage
//                                                 }
//                                                 alt="Bot"
//                                                 className="bot-avatar-img"
//                                             />

//                                         </div>

//                                         <div className="bot-message-content">

//                                             {/* ==================================================
//                                                 BOT CONTENT
//                                             ================================================== */}

//                                             <div className="message-text">

//                                                 {renderMessageContent(
//                                                     message.text
//                                                 )}

//                                             </div>

//                                             <div className="message-footer">

//                                                 <div className="message-time">

//                                                     {
//                                                         message.timestamp
//                                                     }

//                                                 </div>

//                                                 {message.isError && (

//                                                     <button
//                                                         className="inline-retry-btn"
//                                                         onClick={() =>
//                                                             setShowNetworkError(
//                                                                 true
//                                                             )
//                                                         }
//                                                     >
//                                                         Retry
//                                                     </button>

//                                                 )}

//                                             </div>

//                                         </div>

//                                     </div>

//                                     {/* ==================================================
//                                         FOLLOW-UP OPTIONS
//                                     ================================================== */}

//                                     {showCurrentFollowUps && (

//                                         <div
//                                             className="followup-container-outer"
//                                             style={{
//                                                 margin:
//                                                     "6px 0 12px 40px",

//                                                 display:
//                                                     "flex",

//                                                 flexDirection:
//                                                     "column",

//                                                 gap:
//                                                     "6px",

//                                                 maxWidth:
//                                                     "80%"
//                                             }}
//                                         >

//                                             {dynamicOptions.map(
//                                                 (opt) => {

//                                                     const buttonText =
//                                                         getOptionText(
//                                                             opt
//                                                         );

//                                                     if (
//                                                         !buttonText
//                                                     ) {

//                                                         return null;
//                                                     }

//                                                     return (

//                                                         <button
//                                                             key={
//                                                                 getOptionId(
//                                                                     opt
//                                                                 ) ||
//                                                                 buttonText
//                                                             }

//                                                             className="option-button followup-chip"

//                                                             style={{
//                                                                 fontSize:
//                                                                     "11px",

//                                                                 padding:
//                                                                     "8px 14px",

//                                                                 borderRadius:
//                                                                     "12px",

//                                                                 background:
//                                                                     "#f0f2f5",

//                                                                 color:
//                                                                     "#333",

//                                                                 border:
//                                                                     "1px solid #e4e6eb",

//                                                                 textAlign:
//                                                                     "left",

//                                                                 cursor:
//                                                                     "pointer",

//                                                                 transition:
//                                                                     "background 0.2s"
//                                                             }}

//                                                             onClick={() =>
//                                                                 handleFollowUpClick(
//                                                                     opt
//                                                                 )
//                                                             }
//                                                         >

//                                                             {
//                                                                 buttonText
//                                                             }

//                                                         </button>
//                                                     );
//                                                 }
//                                             )}

//                                         </div>
//                                     )}

//                                 </React.Fragment>
//                             );
//                         }
//                     )}

//                     {/* ==================================================
//                         COURSE SUGGESTION FORM
//                     ================================================== */}

//                     {showCourseSuggestionForm &&
//                         !isTyping && (

//                         <div className="course-suggestion-form-wrapper">

//                             <div className="course-suggestion-form">

//                                 <label
//                                     htmlFor="course-suggestion"
//                                     className="course-suggestion-label"
//                                 >
//                                     Preferred Course Name
//                                 </label>

//                                 <input
//                                     id="course-suggestion"
//                                     type="text"
//                                     value={
//                                         courseSuggestion
//                                     }
//                                     onChange={(e) => {

//                                         const value =
//                                             e.target.value.slice(
//                                                 0,
//                                                 150
//                                             );

//                                         setCourseSuggestion(
//                                             value
//                                         );
//                                     }}
//                                     onKeyDown={(e) => {

//                                         /*
//                                          * Allow Enter to submit.
//                                          */

//                                         if (
//                                             e.key ===
//                                             "Enter"
//                                         ) {

//                                             e.preventDefault();

//                                             if (
//                                                 courseSuggestion.trim() &&
//                                                 !isSubmittingSuggestion
//                                             ) {

//                                                 handleCourseSuggestionSubmit();
//                                             }
//                                         }
//                                     }}
//                                     placeholder="Enter your preferred course name..."
//                                     maxLength={150}
//                                     disabled={
//                                         isSubmittingSuggestion
//                                     }
//                                     className="course-suggestion-input"
//                                 />

//                                 <div className="course-suggestion-footer">

//                                     <span className="course-suggestion-counter">

//                                         {
//                                             courseSuggestion.length
//                                         }
//                                         /150

//                                     </span>

//                                     <button
//                                         type="button"
//                                         className="course-suggestion-submit"
//                                         disabled={
//                                             !courseSuggestion.trim() ||
//                                             isSubmittingSuggestion
//                                         }
//                                         onClick={
//                                             handleCourseSuggestionSubmit
//                                         }
//                                     >

//                                         {isSubmittingSuggestion
//                                             ? "Submitting..."
//                                             : "Submit"}

//                                     </button>

//                                 </div>

//                             </div>

//                         </div>
//                     )}

//                     {/* ==================================================
//                         TYPING INDICATOR
//                     ================================================== */}

//                     {isTyping && (

//                         <div className="message bot-message">

//                             <div className="bot-avatar-small">

//                                 <img
//                                     src={
//                                         botImage
//                                     }
//                                     alt="Bot"
//                                     className="bot-avatar-img"
//                                 />

//                             </div>

//                             <div className="bot-message-content">

//                                 <div className="typing-indicator">

//                                     <span></span>
//                                     <span></span>
//                                     <span></span>

//                                 </div>

//                             </div>

//                         </div>
//                     )}

//                 </div>

//             </div>

//             {/* ==================================================
//                 BACK TO MAIN MENU
//             ================================================== */}

//             {showBackToWelcome && (

//                 <div className="chat-navigation-footer">

//                     <button
//                         type="button"
//                         className="back-to-welcome-btn"
//                         onClick={
//                             handleBackToWelcome
//                         }
//                     >
//                         Back to Main menu
//                     </button>

//                 </div>
//             )}

//             {/* ==================================================
//                 NETWORK ERROR MODAL
//             ================================================== */}

//             <NetworkErrorModal
//                 isOpen={
//                     showNetworkError
//                 }

//                 onRetry={
//                     handleRetryNetwork
//                 }

//                 onClose={() =>
//                     setShowNetworkError(
//                         false
//                     )
//                 }
//             />

//             {/* ==================================================
//                 END CHAT MODAL
//             ================================================== */}

//             <EndChatModal
//                 isOpen={
//                     showEndChatModal
//                 }

//                 onClose={() =>
//                     setShowEndChatModal(
//                         false
//                     )
//                 }

//                 onEndChat={
//                     confirmEndChat
//                 }
//             />

//         </div>
//     );
// };

// export default ChatScreen;



// 2 Version

// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import botImage from "../../assets/images/chatbot_icon.png";
// import NetworkErrorModal from "./NetworkErrorModal";
// import EndChatModal from "./EndChatModal";

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const getTime = () => {
//     return new Date().toLocaleTimeString([], {
//         hour: "2-digit",
//         minute: "2-digit",
//     });
// };

// const getOptionText = (optionItem) => {
//     if (typeof optionItem === "string") {
//         return optionItem;
//     }

//     return (
//         optionItem?.option_name ||
//         optionItem?.question ||
//         optionItem?.title ||
//         optionItem?.option_text ||
//         ""
//     );
// };

// const getOptionId = (optionItem) => {
//     if (!optionItem || typeof optionItem === "string") {
//         return null;
//     }

//     return (
//         optionItem.content_id ||
//         optionItem.option_id ||
//         optionItem.faq_id ||
//         optionItem.id ||
//         null
//     );
// };

// const renderInlineContent = (text, lineIndex) => {
//     if (!text) {
//         return null;
//     }

//     const combinedRegex =
//         /(\*\*([^*]+)\*\*)|(\[([^\]]+)\]\((https?:\/\/[^\s)]+)\))|(https?:\/\/[^\s<]+)|([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})|(\+?\d[\d\s().-]{7,}\d)/g;

//     const parts = [];
//     let lastIndex = 0;
//     let match;
//     let partIndex = 0;

//     while ((match = combinedRegex.exec(text)) !== null) {
//         if (match.index > lastIndex) {
//             parts.push(
//                 <React.Fragment
//                     key={`text-${lineIndex}-${partIndex++}`}
//                 >
//                     {text.substring(
//                         lastIndex,
//                         match.index
//                     )}
//                 </React.Fragment>
//             );
//         }

//         if (match[1]) {
//             parts.push(
//                 <strong
//                     key={`bold-${lineIndex}-${partIndex++}`}
//                 >
//                     {match[2]}
//                 </strong>
//             );
//         } else if (match[3]) {
//             parts.push(
//                 <a
//                     key={`markdown-link-${lineIndex}-${partIndex++}`}
//                     href={match[5]}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="chat-content-link"
//                 >
//                     {match[4]}
//                 </a>
//             );
//         } else if (match[6]) {
//             const rawUrl = match[6];
//             const trailingMatch =
//                 rawUrl.match(/[.,!?;:]+$/);

//             const cleanUrl =
//                 trailingMatch
//                     ? rawUrl.substring(
//                         0,
//                         rawUrl.length -
//                         trailingMatch[0].length
//                     )
//                     : rawUrl;

//             const trailingText =
//                 trailingMatch
//                     ? trailingMatch[0]
//                     : "";

//             parts.push(
//                 <a
//                     key={`url-${lineIndex}-${partIndex++}`}
//                     href={cleanUrl}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="chat-content-link"
//                 >
//                     {cleanUrl}
//                 </a>
//             );

//             if (trailingText) {
//                 parts.push(
//                     <React.Fragment
//                         key={`punctuation-${lineIndex}-${partIndex++}`}
//                     >
//                         {trailingText}
//                     </React.Fragment>
//                 );
//             }
//         } else if (match[7]) {
//             const emailAddress = match[7];

//             parts.push(
//                 <a
//                     key={`email-${lineIndex}-${partIndex++}`}
//                     href={`mailto:${emailAddress}`}
//                     className="chat-content-link chat-email-link"
//                 >
//                     {emailAddress}
//                 </a>
//             );
//         } else if (match[8]) {
//             const phoneNumber = match[8];
//             const cleanPhoneNumber =
//                 phoneNumber.replace(
//                     /[\s().-]/g,
//                     ""
//                 );

//             parts.push(
//                 <a
//                     key={`phone-${lineIndex}-${partIndex++}`}
//                     href={`tel:${cleanPhoneNumber}`}
//                     className="chat-content-link chat-phone-link"
//                 >
//                     {phoneNumber}
//                 </a>
//             );
//         }

//         lastIndex = combinedRegex.lastIndex;
//     }

//     if (lastIndex < text.length) {
//         parts.push(
//             <React.Fragment
//                 key={`remaining-${lineIndex}-${partIndex++}`}
//             >
//                 {text.substring(lastIndex)}
//             </React.Fragment>
//         );
//     }

//     if (parts.length === 0) {
//         return text;
//     }

//     return parts;
// };

// const renderMessageContent = (text) => {
//     if (!text) {
//         return null;
//     }

//     const lines = String(text).split(/\r?\n/);

//     return (
//         <div className="chat-message-content-rendered">
//             {lines.map((line, index) => {
//                 const trimmedLine = line.trim();

//                 if (!trimmedLine) {
//                     return (
//                         <div
//                             key={`empty-${index}`}
//                             className="chat-content-empty-line"
//                         />
//                     );
//                 }

//                 if (
//                     trimmedLine.startsWith("* ") ||
//                     trimmedLine.startsWith("- ")
//                 ) {
//                     const bulletText =
//                         trimmedLine
//                             .substring(2)
//                             .trim();

//                     return (
//                         <div
//                             key={`bullet-${index}`}
//                             className="chat-content-bullet"
//                         >
//                             <span className="chat-bullet-dot">
//                                 •
//                             </span>
//                             <span>
//                                 {renderInlineContent(
//                                     bulletText,
//                                     index
//                                 )}
//                             </span>
//                         </div>
//                     );
//                 }

//                 return (
//                     <div
//                         key={`line-${index}`}
//                         className="chat-content-line"
//                     >
//                         {renderInlineContent(
//                             line,
//                             index
//                         )}
//                     </div>
//                 );
//             })}
//         </div>
//     );
// };

// const ChatScreen = ({
//     onClose,
//     user,
//     setScreen,
//     pendingMessage,
//     setPendingMessage
// }) => {
//     const [sessionId] = useState(() => {
//         return user?.email
//             ? `session_${btoa(user.email).replace(/=/g, "")}`
//             : `session_${Date.now()}`;
//     });

//     const [messages, setMessages] = useState(() => {
//         try {
//             const savedMessages =
//                 localStorage.getItem(
//                     "chatbot_messages"
//                 );

//             if (savedMessages) {
//                 return JSON.parse(
//                     savedMessages
//                 );
//             }
//         } catch (error) {
//             console.error(
//                 "Could not parse saved messages",
//                 error
//             );
//         }

//         return [
//             {
//                 id: 1,
//                 sender: "bot",
//                 text: `Hello ${user?.name || "there"} 👋`,
//                 timestamp: getTime(),
//             },
//             {
//                 id: 2,
//                 sender: "bot",
//                 text: "How can I help you today?",
//                 timestamp: getTime(),
//             },
//         ];
//     });

//     const [inputMessage, setInputMessage] = useState("");
//     const [isTyping, setIsTyping] = useState(false);

//     const [dynamicOptions, setDynamicOptions] = useState(() => {
//         try {
//             const saved =
//                 localStorage.getItem(
//                     "chatbot_dynamicOptions"
//                 );

//             if (saved) {
//                 return JSON.parse(saved);
//             }
//         } catch (error) {
//             console.error(
//                 "Could not parse dynamic options",
//                 error
//             );
//         }

//         return [];
//     });

//     const [isFinal, setIsFinal] = useState(() => {
//         try {
//             return (
//                 localStorage.getItem(
//                     "chatbot_isFinal"
//                 ) === "true"
//             );
//         } catch (error) {
//             return false;
//         }
//     });

//     const [showNetworkError, setShowNetworkError] = useState(false);
//     const [showEndChatModal, setShowEndChatModal] = useState(false);
//     const [courseSuggestion, setCourseSuggestion] = useState("");
//     const [isSubmittingSuggestion, setIsSubmittingSuggestion] = useState(false);
//     const [showCourseSuggestionForm, setShowCourseSuggestionForm] = useState(false);

//     const chatBodyRef = useRef(null);
//     const pendingProcessedRef = useRef(false);

//     useEffect(() => {
//         try {
//             localStorage.setItem(
//                 "chatbot_dynamicOptions",
//                 JSON.stringify(dynamicOptions)
//             );
//         } catch (error) {
//             console.error(
//                 "Could not save dynamic options",
//                 error
//             );
//         }
//     }, [dynamicOptions]);

//     useEffect(() => {
//         try {
//             localStorage.setItem(
//                 "chatbot_isFinal",
//                 String(isFinal)
//             );
//         } catch (error) {
//             console.error(
//                 "Could not save final state",
//                 error
//             );
//         }
//     }, [isFinal]);

//     const extractBackendData = (responseData) => {
//         const data = responseData?.data || {};

//         const answer =
//             responseData?.answer ??
//             data?.answer ??
//             data?.content ??
//             responseData?.content ??
//             "";

//         const followups =
//             Array.isArray(responseData?.followups)
//                 ? responseData.followups
//                 : Array.isArray(data?.followups)
//                     ? data.followups
//                     : [];

//         const nextQuestions =
//             Array.isArray(responseData?.next_questions)
//                 ? responseData.next_questions
//                 : Array.isArray(data?.next_questions)
//                     ? data.next_questions
//                     : [];

//         const final =
//             responseData?.is_final === true ||
//             data?.is_final === true;

//         return {
//             answer,
//             followups,
//             nextQuestions,
//             isFinal: final,
//         };
//     };

//     const handleCourseSuggestionSubmit = async () => {
//         const courseName = courseSuggestion.trim();

//         if (!courseName) {
//             return;
//         }

//         if (courseName.length > 150) {
//             return;
//         }

//         setIsSubmittingSuggestion(true);

//         setMessages((prev) => [
//             ...prev,
//             {
//                 id: Date.now(),
//                 sender: "user",
//                 text: courseName,
//                 timestamp: getTime(),
//             },
//         ]);

//         setShowCourseSuggestionForm(false);
//         setCourseSuggestion("");

//         try {
//             const response = await axios.post(
//                 `${API_BASE_URL}/suggest-course`,
//                 {
//                     suggested_course: courseName,
//                     session_id: sessionId,
//                     created_by_ip: "chatbot-web",
//                 }
//             );

//             console.log(
//                 "Course suggestion response:",
//                 response.data
//             );

//             const {
//                 answer,
//                 followups,
//                 nextQuestions,
//                 isFinal: responseIsFinal
//             } = extractBackendData(response.data);

//             setMessages((prev) => [
//                 ...prev,
//                 {
//                     id: Date.now(),
//                     sender: "bot",
//                     text:
//                         answer ||
//                         "Thank you for your valuable suggestion! We appreciate your feedback.",
//                     timestamp: getTime(),
//                 },
//             ]);

//             if (
//                 followups.length > 0 ||
//                 nextQuestions.length > 0
//             ) {
//                 setDynamicOptions(
//                     followups.length > 0
//                         ? followups
//                         : nextQuestions
//                 );
//             } else {
//                 setDynamicOptions([]);
//             }

//             setIsFinal(responseIsFinal);
//         } catch (error) {
//             console.error(
//                 "Course suggestion submission error:",
//                 error
//             );

//             setMessages((prev) => [
//                 ...prev,
//                 {
//                     id: Date.now(),
//                     sender: "bot",
//                     text:
//                         error?.response?.data?.detail ||
//                         "We could not submit your course suggestion right now. Please try again later.",
//                     timestamp: getTime(),
//                     isError: true,
//                 },
//             ]);

//             setDynamicOptions([]);
//             setIsFinal(false);
//         } finally {
//             setIsSubmittingSuggestion(false);
//         }
//     };

//     const handleOptionClick = async (
//         optionItem,
//         fallbackFollowUps = []
//     ) => {
//         const optionText = getOptionText(optionItem);
//         const targetOptionId = getOptionId(optionItem);

//         if (!optionText) {
//             return;
//         }

//         if (
//             Number(targetOptionId) === 9 ||
//             optionText === "Suggest a New Course"
//         ) {
//             setMessages((prev) => [
//                 ...prev,
//                 {
//                     id: Date.now(),
//                     sender: "user",
//                     text: optionText,
//                     timestamp: getTime(),
//                 },
//             ]);

//             setDynamicOptions([]);
//             setIsFinal(false);
//             setIsTyping(true);

//             setTimeout(() => {
//                 setMessages((prev) => [
//                     ...prev,
//                     {
//                         id: Date.now(),
//                         sender: "bot",
//                         text:
//                             `Could not find the course you were looking for?\n\nInterested in a course that is not listed? Let us know!\n\nStay tuned with us for upcoming courses. We are continuously expanding our course catalog based on industry trends and learner demand.\n\nPlease enter the course you would like SwiftIntelli to offer.`,
//                         timestamp: getTime(),
//                     },
//                 ]);

//                 setShowCourseSuggestionForm(true);
//                 setIsTyping(false);
//             }, 400);

//             return;
//         }

//         setMessages((prev) => {
//             const alreadyPushed = prev.some(
//                 (message) =>
//                     message.sender === "user" &&
//                     message.text === optionText &&
//                     Date.now() - message.id < 100
//             );

//             if (alreadyPushed) {
//                 return prev;
//             }

//             return [
//                 ...prev,
//                 {
//                     id: Date.now(),
//                     sender: "user",
//                     text: optionText,
//                     timestamp: getTime(),
//                 },
//             ];
//         });

//         if (optionText === "Others...") {
//             setIsFinal(false);
//             setDynamicOptions([]);
//             setIsTyping(true);

//             setTimeout(() => {
//                 setMessages((prev) => [
//                     ...prev,
//                     {
//                         id: Date.now(),
//                         sender: "bot",
//                         text: "Please type your specific query below!",
//                         timestamp: getTime(),
//                     },
//                 ]);

//                 setIsTyping(false);
//             }, 400);

//             return;
//         }

//         if (!targetOptionId) {
//             await handleCustomChat(optionText);
//             return;
//         }

//         setIsTyping(true);

//         try {
//             const isFaq =
//                 optionItem?.question !== undefined ||
//                 optionItem?.title !== undefined ||
//                 optionItem?.faq_id !== undefined ||
//                 optionItem?.content_id !== undefined;

//             const endpointUrl = isFaq
//                 ? `${API_BASE_URL}/faq-answer/${targetOptionId}`
//                 : `${API_BASE_URL}/sub-option-answer/${targetOptionId}`;

//             console.log("Chatbot request:", endpointUrl);

//             const response = await axios.get(endpointUrl);

//             console.log("Chatbot response:", response.data);

//             if (response.status !== 200) {
//                 throw new Error("Unexpected response status");
//             }

//             const {
//                 answer,
//                 followups,
//                 nextQuestions,
//                 isFinal: responseIsFinal
//             } = extractBackendData(response.data);

//             const answerContent =
//                 answer || "Here is the information you requested.";

//             let optionsToShow = [];

//             if (followups.length > 0) {
//                 optionsToShow = followups;
//             } else if (nextQuestions.length > 0) {
//                 optionsToShow = nextQuestions;
//             } else {
//                 optionsToShow = fallbackFollowUps || [];
//             }

//             setMessages((prev) => [
//                 ...prev,
//                 {
//                     id: Date.now(),
//                     sender: "bot",
//                     text: answerContent,
//                     timestamp: getTime(),
//                 },
//             ]);

//             setDynamicOptions(optionsToShow);
//             setIsFinal(responseIsFinal);
//         } catch (error) {
//             console.error(
//                 "Database structural response retrieval error:",
//                 error
//             );
//             handleErrorFallback();
//         } finally {
//             setIsTyping(false);
//         }
//     };

//     const handleCustomChat = async (messageText) => {
//         setIsTyping(true);

//         try {
//             const response = await axios.post(`${API_BASE_URL}/chat`, {
//                 session_id: sessionId,
//                 message: messageText,
//             });

//             if (response.data && response.data.success) {
//                 const {
//                     answer,
//                     followups,
//                     nextQuestions,
//                     isFinal: responseIsFinal
//                 } = extractBackendData(response.data);

//                 setMessages((prev) => [
//                     ...prev,
//                     {
//                         id: response.data.log_id || Date.now(),
//                         sender: "bot",
//                         text:
//                             answer ||
//                             "Here is the information you requested.",
//                         timestamp: getTime(),
//                     },
//                 ]);

//                 if (
//                     followups.length > 0 ||
//                     nextQuestions.length > 0
//                 ) {
//                     setDynamicOptions(
//                         followups.length > 0
//                             ? followups
//                             : nextQuestions
//                     );
//                 } else {
//                     setDynamicOptions([]);
//                 }

//                 setIsFinal(responseIsFinal);
//             } else {
//                 throw new Error(
//                     response.data?.message || "Chat request failed"
//                 );
//             }
//         } catch (error) {
//             console.error(
//                 "Chat engine communication error:",
//                 error
//             );
//             handleErrorFallback();
//         } finally {
//             setIsTyping(false);
//         }
//     };

//     const handleFollowUpClick = (optItem) => {
//         const optId = getOptionId(optItem);
//         let remainingFollowUps;

//         if (optId !== null) {
//             remainingFollowUps = dynamicOptions.filter(
//                 (item) => getOptionId(item) !== optId
//             );
//         } else {
//             const clickedText = getOptionText(optItem);
//             remainingFollowUps = dynamicOptions.filter(
//                 (item) => getOptionText(item) !== clickedText
//             );
//         }

//         setDynamicOptions(remainingFollowUps);
//         setIsFinal(false);
//         handleOptionClick(optItem, remainingFollowUps);
//     };

//     const handleErrorFallback = () => {
//         setMessages((prev) => [
//             ...prev,
//             {
//                 id: Date.now(),
//                 sender: "bot",
//                 text:
//                     "Something went wrong. Please try again after sometime.",
//                 timestamp: getTime(),
//                 isError: true,
//             },
//         ]);

//         setDynamicOptions([]);
//         setIsFinal(false);
//         setShowNetworkError(true);
//     };

//     const handleEndChat = () => {
//         setShowEndChatModal(true);
//     };

//     const confirmEndChat = () => {
//         axios
//             .post(`${API_BASE_URL}/end-chat`, {
//                 session_id: sessionId,
//             })
//             .catch((error) =>
//                 console.error(
//                     "Clean session termination failed:",
//                     error
//                 )
//             );

//         setShowEndChatModal(false);
//         localStorage.removeItem("chatbot_messages");
//         localStorage.removeItem("chatbot_dynamicOptions");
//         localStorage.removeItem("chatbot_isFinal");

//         setDynamicOptions([]);
//         setIsFinal(false);
//         setShowCourseSuggestionForm(false);
//         setCourseSuggestion("");
//         setScreen("welcome");
//     };

//     const handleRetryNetwork = () => {
//         setShowNetworkError(false);
//     };

//     const handleBackToWelcome = () => {
//         setDynamicOptions([]);
//         setIsFinal(false);
//         setPendingMessage("");
//         setShowCourseSuggestionForm(false);
//         setCourseSuggestion("");

//         localStorage.removeItem("chatbot_messages");
//         localStorage.removeItem("chatbot_dynamicOptions");
//         localStorage.removeItem("chatbot_isFinal");

//         setScreen("welcome");
//     };

//     useEffect(() => {
//         if (pendingMessage && !pendingProcessedRef.current) {
//             pendingProcessedRef.current = true;
//             const messageToProcess = pendingMessage;

//             setDynamicOptions([]);
//             setIsFinal(false);
//             setPendingMessage("");
//             handleOptionClick(messageToProcess);
//         }

//         if (!pendingMessage) {
//             pendingProcessedRef.current = false;
//         }
//     }, [pendingMessage]);

//     useEffect(() => {
//         try {
//             localStorage.setItem(
//                 "chatbot_messages",
//                 JSON.stringify(messages)
//             );
//         } catch (error) {
//             console.error(
//                 "Could not save messages",
//                 error
//             );
//         }
//     }, [messages]);

//     useEffect(() => {
//         if (chatBodyRef.current) {
//             chatBodyRef.current.scrollTop =
//                 chatBodyRef.current.scrollHeight;
//         }
//     }, [
//         messages,
//         isTyping,
//         dynamicOptions,
//         showCourseSuggestionForm
//     ]);

//     const handleSendMessage = () => {
//         if (!inputMessage.trim()) {
//             return;
//         }

//         const userText = inputMessage.trim();

//         setMessages((prev) => [
//             ...prev,
//             {
//                 id: Date.now(),
//                 sender: "user",
//                 text: userText,
//                 timestamp: getTime(),
//             },
//         ]);

//         setInputMessage("");
//         setDynamicOptions([]);
//         setIsFinal(false);
//         handleCustomChat(userText);
//     };

//     const hasDynamicOptions = dynamicOptions.length > 0;
//     const showBackToWelcome =
//         isFinal &&
//         !isTyping &&
//         !hasDynamicOptions &&
//         !showCourseSuggestionForm;

//     return (
//         <div className="chat-screen-container">
//             <div className="chat-header">
//                 <div className="chat-header-left">
//                     <div className="chat-avatar-wrapper">
//                         <img
//                             src={botImage}
//                             alt="Bot"
//                             className="chat-avatar-img"
//                         />
//                     </div>
//                     <div>
//                         <h4 className="chat-title">
//                             IntelliBot
//                         </h4>
//                         <div className="chat-status">
//                             Online
//                         </div>
//                     </div>
//                 </div>
//                 <button
//                     className="end-chat-btn"
//                     onClick={handleEndChat}
//                 >
//                     End Chat
//                 </button>
//             </div>

//             <div
//                 className="chat-body"
//                 ref={chatBodyRef}
//             >
//                 <div className="chat-messages">
//                     {messages.map((message, idx) => {
//                         if (message.sender === "user") {
//                             return (
//                                 <div
//                                     key={message.id}
//                                     className="message user-message"
//                                 >
//                                     <div className="message-text">
//                                         {message.text}
//                                     </div>
//                                     <div className="message-time">
//                                         {message.timestamp}
//                                     </div>
//                                 </div>
//                             );
//                         }

//                         const isLatestBotMessage =
//                             idx === messages.length - 1;
//                         const showCurrentFollowUps =
//                             isLatestBotMessage && hasDynamicOptions;

//                         return (
//                             <React.Fragment key={message.id}>
//                                 <div
//                                     className={`message bot-message ${
//                                         message.isError
//                                             ? "error-bubble"
//                                             : ""
//                                     }`}
//                                 >
//                                     <div className="bot-avatar-small">
//                                         <img
//                                             src={botImage}
//                                             alt="Bot"
//                                             className="bot-avatar-img"
//                                         />
//                                     </div>
//                                     <div className="bot-message-content">
//                                         <div className="message-text">
//                                             {renderMessageContent(
//                                                 message.text
//                                             )}
//                                         </div>
//                                         <div className="message-footer">
//                                             <div className="message-time">
//                                                 {message.timestamp}
//                                             </div>
//                                             {message.isError && (
//                                                 <button
//                                                     className="inline-retry-btn"
//                                                     onClick={() =>
//                                                         setShowNetworkError(true)
//                                                     }
//                                                 >
//                                                     Retry
//                                                 </button>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {showCurrentFollowUps && (
//                                     <div
//                                         className="followup-container-outer"
//                                         style={{
//                                             margin: "6px 0 12px 40px",
//                                             display: "flex",
//                                             flexDirection: "column",
//                                             gap: "6px",
//                                             maxWidth: "80%"
//                                         }}
//                                     >
//                                         {dynamicOptions.map((opt) => {
//                                             const buttonText =
//                                                 getOptionText(opt);

//                                             if (!buttonText) {
//                                                 return null;
//                                             }

//                                             return (
//                                                 <button
//                                                     key={
//                                                         getOptionId(opt) ||
//                                                         buttonText
//                                                     }
//                                                     className="option-button followup-chip"
//                                                     style={{
//                                                         fontSize: "11px",
//                                                         padding: "8px 14px",
//                                                         borderRadius: "12px",
//                                                         background: "#f0f2f5",
//                                                         color: "#333",
//                                                         border: "1px solid #e4e6eb",
//                                                         textAlign: "left",
//                                                         cursor: "pointer",
//                                                         transition: "background 0.2s"
//                                                     }}
//                                                     onClick={() =>
//                                                         handleFollowUpClick(opt)
//                                                     }
//                                                 >
//                                                     {buttonText}
//                                                 </button>
//                                             );
//                                         })}
//                                     </div>
//                                 )}
//                             </React.Fragment>
//                         );
//                     })}

//                     {showCourseSuggestionForm && !isTyping && (
//                         <div className="course-suggestion-form-wrapper">
//                             <div className="course-suggestion-form">
//                                 <label
//                                     htmlFor="course-suggestion"
//                                     className="course-suggestion-label"
//                                 >
//                                     Preferred Course Name
//                                 </label>
//                                 <input
//                                     id="course-suggestion"
//                                     type="text"
//                                     value={courseSuggestion}
//                                     onChange={(e) => {
//                                         const value = e.target.value.slice(
//                                             0,
//                                             150
//                                         );
//                                         setCourseSuggestion(value);
//                                     }}
//                                     onKeyDown={(e) => {
//                                         if (e.key === "Enter") {
//                                             e.preventDefault();
//                                             if (
//                                                 courseSuggestion.trim() &&
//                                                 !isSubmittingSuggestion
//                                             ) {
//                                                 handleCourseSuggestionSubmit();
//                                             }
//                                         }
//                                     }}
//                                     placeholder="Enter your preferred course name..."
//                                     maxLength={150}
//                                     disabled={isSubmittingSuggestion}
//                                     className="course-suggestion-input"
//                                 />
//                                 <div className="course-suggestion-footer">
//                                     <span className="course-suggestion-counter">
//                                         {courseSuggestion.length}/150
//                                     </span>
//                                     <button
//                                         type="button"
//                                         className="course-suggestion-submit"
//                                         disabled={
//                                             !courseSuggestion.trim() ||
//                                             isSubmittingSuggestion
//                                         }
//                                         onClick={
//                                             handleCourseSuggestionSubmit
//                                         }
//                                     >
//                                         {isSubmittingSuggestion
//                                             ? "Submitting..."
//                                             : "Submit"}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     )}

//                     {isTyping && (
//                         <div className="message bot-message">
//                             <div className="bot-avatar-small">
//                                 <img
//                                     src={botImage}
//                                     alt="Bot"
//                                     className="bot-avatar-img"
//                                 />
//                             </div>
//                             <div className="bot-message-content">
//                                 <div className="typing-indicator">
//                                     <span></span>
//                                     <span></span>
//                                     <span></span>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             </div>

//             {showBackToWelcome && (
//                 <div className="chat-navigation-footer">
//                     <button
//                         type="button"
//                         className="back-to-welcome-btn"
//                         onClick={handleBackToWelcome}
//                     >
//                         Back to Main menu
//                     </button>
//                 </div>
//             )}

//             <NetworkErrorModal
//                 isOpen={showNetworkError}
//                 onRetry={handleRetryNetwork}
//                 onClose={() => setShowNetworkError(false)}
//             />

//             <EndChatModal
//                 isOpen={showEndChatModal}
//                 onClose={() => setShowEndChatModal(false)}
//                 onEndChat={confirmEndChat}
//             />
//         </div>
//     );
// };

// export default ChatScreen;


// 3 Version


// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import botImage from "../../assets/images/chatbot_icon.png";
// import NetworkErrorModal from "./NetworkErrorModal";
// import EndChatModal from "./EndChatModal";

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const getTime = () => {
//     return new Date().toLocaleTimeString([], {
//         hour: "2-digit",
//         minute: "2-digit",
//     });
// };

// const getOptionText = (optionItem) => {
//     if (typeof optionItem === "string") {
//         return optionItem;
//     }

//     return (
//         optionItem?.option_name ||
//         optionItem?.question ||
//         optionItem?.title ||
//         optionItem?.option_text ||
//         ""
//     );
// };

// const getOptionId = (optionItem) => {
//     if (!optionItem || typeof optionItem === "string") {
//         return null;
//     }

//     return (
//         optionItem.content_id ||
//         optionItem.option_id ||
//         optionItem.faq_id ||
//         optionItem.id ||
//         null
//     );
// };

// const renderInlineContent = (text, lineIndex) => {
//     if (!text) {
//         return null;
//     }

//     const combinedRegex =
//         /(\*\*([^*]+)\*\*)|(\[([^\]]+)\]\((https?:\/\/[^\s)]+)\))|(https?:\/\/[^\s<]+)|([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})|(\+?\d[\d\s().-]{7,}\d)/g;

//     const parts = [];
//     let lastIndex = 0;
//     let match;
//     let partIndex = 0;

//     while ((match = combinedRegex.exec(text)) !== null) {
//         if (match.index > lastIndex) {
//             parts.push(
//                 <React.Fragment
//                     key={`text-${lineIndex}-${partIndex++}`}
//                 >
//                     {text.substring(
//                         lastIndex,
//                         match.index
//                     )}
//                 </React.Fragment>
//             );
//         }

//         if (match[1]) {
//             parts.push(
//                 <strong
//                     key={`bold-${lineIndex}-${partIndex++}`}
//                 >
//                     {match[2]}
//                 </strong>
//             );
//         } else if (match[3]) {
//             parts.push(
//                 <a
//                     key={`markdown-link-${lineIndex}-${partIndex++}`}
//                     href={match[5]}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="chat-content-link"
//                 >
//                     {match[4]}
//                 </a>
//             );
//         } else if (match[6]) {
//             const rawUrl = match[6];
//             const trailingMatch =
//                 rawUrl.match(/[.,!?;:]+$/);

//             const cleanUrl =
//                 trailingMatch
//                     ? rawUrl.substring(
//                         0,
//                         rawUrl.length -
//                         trailingMatch[0].length
//                     )
//                     : rawUrl;

//             const trailingText =
//                 trailingMatch
//                     ? trailingMatch[0]
//                     : "";

//             parts.push(
//                 <a
//                     key={`url-${lineIndex}-${partIndex++}`}
//                     href={cleanUrl}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="chat-content-link"
//                 >
//                     {cleanUrl}
//                 </a>
//             );

//             if (trailingText) {
//                 parts.push(
//                     <React.Fragment
//                         key={`punctuation-${lineIndex}-${partIndex++}`}
//                     >
//                         {trailingText}
//                     </React.Fragment>
//                 );
//             }
//         } else if (match[7]) {
//             const emailAddress = match[7];

//             parts.push(
//                 <a
//                     key={`email-${lineIndex}-${partIndex++}`}
//                     href={`mailto:${emailAddress}`}
//                     className="chat-content-link chat-email-link"
//                 >
//                     {emailAddress}
//                 </a>
//             );
//         } else if (match[8]) {
//             const phoneNumber = match[8];
//             const cleanPhoneNumber =
//                 phoneNumber.replace(
//                     /[\s().-]/g,
//                     ""
//                 );

//             parts.push(
//                 <a
//                     key={`phone-${lineIndex}-${partIndex++}`}
//                     href={`tel:${cleanPhoneNumber}`}
//                     className="chat-content-link chat-phone-link"
//                 >
//                     {phoneNumber}
//                 </a>
//             );
//         }

//         lastIndex = combinedRegex.lastIndex;
//     }

//     if (lastIndex < text.length) {
//         parts.push(
//             <React.Fragment
//                 key={`remaining-${lineIndex}-${partIndex++}`}
//             >
//                 {text.substring(lastIndex)}
//             </React.Fragment>
//         );
//     }

//     if (parts.length === 0) {
//         return text;
//     }

//     return parts;
// };

// const renderMessageContent = (text) => {
//     if (!text) {
//         return null;
//     }

//     const lines = String(text).split(/\r?\n/);

//     return (
//         <div className="chat-message-content-rendered">
//             {lines.map((line, index) => {
//                 const trimmedLine = line.trim();

//                 if (!trimmedLine) {
//                     return (
//                         <div
//                             key={`empty-${index}`}
//                             className="chat-content-empty-line"
//                         />
//                     );
//                 }

//                 if (
//                     trimmedLine.startsWith("* ") ||
//                     trimmedLine.startsWith("- ")
//                 ) {
//                     const bulletText =
//                         trimmedLine
//                             .substring(2)
//                             .trim();

//                     return (
//                         <div
//                             key={`bullet-${index}`}
//                             className="chat-content-bullet"
//                         >
//                             <span className="chat-bullet-dot">
//                                 •
//                             </span>
//                             <span>
//                                 {renderInlineContent(
//                                     bulletText,
//                                     index
//                                 )}
//                             </span>
//                         </div>
//                     );
//                 }

//                 return (
//                     <div
//                         key={`line-${index}`}
//                         className="chat-content-line"
//                     >
//                         {renderInlineContent(
//                             line,
//                             index
//                         )}
//                     </div>
//                 );
//             })}
//         </div>
//     );
// };

// const ChatScreen = ({
//     onClose,
//     user,
//     setScreen,
//     pendingMessage,
//     setPendingMessage
// }) => {
//     const [sessionId] = useState(() => {
//         return user?.email
//             ? `session_${btoa(user.email).replace(/=/g, "")}`
//             : `session_${Date.now()}`;
//     });

//     const [messages, setMessages] = useState(() => {
//         try {
//             const savedMessages =
//                 localStorage.getItem(
//                     "chatbot_messages"
//                 );

//             if (savedMessages) {
//                 return JSON.parse(
//                     savedMessages
//                 );
//             }
//         } catch (error) {
//             console.error(
//                 "Could not parse saved messages",
//                 error
//             );
//         }

//         return [
//             {
//                 id: 1,
//                 sender: "bot",
//                 text: `Hello ${user?.name || "there"} 👋`,
//                 timestamp: getTime(),
//             },
//             {
//                 id: 2,
//                 sender: "bot",
//                 text: "How can I help you today?",
//                 timestamp: getTime(),
//             },
//         ];
//     });

//     const [inputMessage, setInputMessage] = useState("");
//     const [isTyping, setIsTyping] = useState(false);

//     const [dynamicOptions, setDynamicOptions] = useState(() => {
//         try {
//             const saved =
//                 localStorage.getItem(
//                     "chatbot_dynamicOptions"
//                 );

//             if (saved) {
//                 return JSON.parse(saved);
//             }
//         } catch (error) {
//             console.error(
//                 "Could not parse dynamic options",
//                 error
//             );
//         }

//         return [];
//     });

//     const [isFinal, setIsFinal] = useState(() => {
//         try {
//             return (
//                 localStorage.getItem(
//                     "chatbot_isFinal"
//                 ) === "true"
//             );
//         } catch (error) {
//             return false;
//         }
//     });

//     const [showNetworkError, setShowNetworkError] = useState(false);
//     const [showEndChatModal, setShowEndChatModal] = useState(false);
//     const [courseSuggestion, setCourseSuggestion] = useState("");
//     const [isSubmittingSuggestion, setIsSubmittingSuggestion] = useState(false);
//     const [showCourseSuggestionForm, setShowCourseSuggestionForm] = useState(false);

//     // Temp storage for follow-up options while suggestion form is open
//     const [savedFollowUps, setSavedFollowUps] = useState([]);

//     const chatBodyRef = useRef(null);
//     const pendingProcessedRef = useRef(false);

//     useEffect(() => {
//         try {
//             localStorage.setItem(
//                 "chatbot_dynamicOptions",
//                 JSON.stringify(dynamicOptions)
//             );
//         } catch (error) {
//             console.error(
//                 "Could not save dynamic options",
//                 error
//             );
//         }
//     }, [dynamicOptions]);

//     useEffect(() => {
//         try {
//             localStorage.setItem(
//                 "chatbot_isFinal",
//                 String(isFinal)
//             );
//         } catch (error) {
//             console.error(
//                 "Could not save final state",
//                 error
//             );
//         }
//     }, [isFinal]);

//     const extractBackendData = (responseData) => {
//         const data = responseData?.data || {};

//         const answer =
//             responseData?.answer ??
//             data?.answer ??
//             data?.content ??
//             responseData?.content ??
//             "";

//         const followups =
//             Array.isArray(responseData?.followups)
//                 ? responseData.followups
//                 : Array.isArray(data?.followups)
//                     ? data.followups
//                     : [];

//         const nextQuestions =
//             Array.isArray(responseData?.next_questions)
//                 ? responseData.next_questions
//                 : Array.isArray(data?.next_questions)
//                     ? data.next_questions
//                     : [];

//         const final =
//             responseData?.is_final === true ||
//             data?.is_final === true;

//         return {
//             answer,
//             followups,
//             nextQuestions,
//             isFinal: final,
//         };
//     };

//     const handleCourseSuggestionSubmit = async () => {
//         const courseName = courseSuggestion.trim();

//         if (!courseName) {
//             return;
//         }

//         if (courseName.length > 150) {
//             return;
//         }

//         setIsSubmittingSuggestion(true);

//         setMessages((prev) => [
//             ...prev,
//             {
//                 id: Date.now(),
//                 sender: "user",
//                 text: courseName,
//                 timestamp: getTime(),
//             },
//         ]);

//         setShowCourseSuggestionForm(false);
//         setCourseSuggestion("");

//         try {
//             const response = await axios.post(
//                 `${API_BASE_URL}/suggest-course`,
//                 {
//                     suggested_course: courseName,
//                     session_id: sessionId,
//                     created_by_ip: "chatbot-web",
//                 }
//             );

//             console.log(
//                 "Course suggestion response:",
//                 response.data
//             );

//             const {
//                 answer,
//                 followups,
//                 nextQuestions,
//                 isFinal: responseIsFinal
//             } = extractBackendData(response.data);

//             setMessages((prev) => [
//                 ...prev,
//                 {
//                     id: Date.now(),
//                     sender: "bot",
//                     text:
//                         answer ||
//                         "Thank you for your valuable suggestion! We appreciate your feedback.",
//                     timestamp: getTime(),
//                 },
//             ]);

//             // Restore new backend followups, or restore unclicked options stored before suggestion form
//             if (followups.length > 0 || nextQuestions.length > 0) {
//                 setDynamicOptions(
//                     followups.length > 0
//                         ? followups
//                         : nextQuestions
//                 );
//             } else if (savedFollowUps.length > 0) {
//                 setDynamicOptions(savedFollowUps);
//             } else {
//                 setDynamicOptions([]);
//             }

//             setSavedFollowUps([]);
//             setIsFinal(responseIsFinal);
//         } catch (error) {
//             console.error(
//                 "Course suggestion submission error:",
//                 error
//             );

//             setMessages((prev) => [
//                 ...prev,
//                 {
//                     id: Date.now(),
//                     sender: "bot",
//                     text:
//                         error?.response?.data?.detail ||
//                         "We could not submit your course suggestion right now. Please try again later.",
//                     timestamp: getTime(),
//                     isError: true,
//                 },
//             ]);

//             if (savedFollowUps.length > 0) {
//                 setDynamicOptions(savedFollowUps);
//             } else {
//                 setDynamicOptions([]);
//             }

//             setSavedFollowUps([]);
//             setIsFinal(false);
//         } finally {
//             setIsSubmittingSuggestion(false);
//         }
//     };

//     const handleOptionClick = async (
//         optionItem,
//         fallbackFollowUps = []
//     ) => {
//         const optionText = getOptionText(optionItem);
//         const targetOptionId = getOptionId(optionItem);

//         if (!optionText) {
//             return;
//         }

//         if (
//             Number(targetOptionId) === 9 ||
//             optionText === "Suggest a New Course"
//         ) {
//             // Store any remaining options that were present on screen before suggestion mode
//             setSavedFollowUps(fallbackFollowUps.length > 0 ? fallbackFollowUps : dynamicOptions);

//             setMessages((prev) => [
//                 ...prev,
//                 {
//                     id: Date.now(),
//                     sender: "user",
//                     text: optionText,
//                     timestamp: getTime(),
//                 },
//             ]);

//             setDynamicOptions([]);
//             setIsFinal(false);
//             setIsTyping(true);

//             setTimeout(() => {
//                 setMessages((prev) => [
//                     ...prev,
//                     {
//                         id: Date.now(),
//                         sender: "bot",
//                         text:
//                             `Could not find the course you were looking for?\n\nInterested in a course that is not listed? Let us know!\n\nStay tuned with us for upcoming courses. We are continuously expanding our course catalog based on industry trends and learner demand.\n\nPlease enter the course you would like SwiftIntelli to offer.`,
//                         timestamp: getTime(),
//                     },
//                 ]);

//                 setShowCourseSuggestionForm(true);
//                 setIsTyping(false);
//             }, 400);

//             return;
//         }

//         setMessages((prev) => {
//             const alreadyPushed = prev.some(
//                 (message) =>
//                     message.sender === "user" &&
//                     message.text === optionText &&
//                     Date.now() - message.id < 100
//             );

//             if (alreadyPushed) {
//                 return prev;
//             }

//             return [
//                 ...prev,
//                 {
//                     id: Date.now(),
//                     sender: "user",
//                     text: optionText,
//                     timestamp: getTime(),
//                 },
//             ];
//         });

//         if (optionText === "Others...") {
//             setIsFinal(false);
//             setDynamicOptions([]);
//             setIsTyping(true);

//             setTimeout(() => {
//                 setMessages((prev) => [
//                     ...prev,
//                     {
//                         id: Date.now(),
//                         sender: "bot",
//                         text: "Please type your specific query below!",
//                         timestamp: getTime(),
//                     },
//                 ]);

//                 setIsTyping(false);
//             }, 400);

//             return;
//         }

//         if (!targetOptionId) {
//             await handleCustomChat(optionText);
//             return;
//         }

//         setIsTyping(true);

//         try {
//             const isFaq =
//                 optionItem?.question !== undefined ||
//                 optionItem?.title !== undefined ||
//                 optionItem?.faq_id !== undefined ||
//                 optionItem?.content_id !== undefined;

//             const endpointUrl = isFaq
//                 ? `${API_BASE_URL}/faq-answer/${targetOptionId}`
//                 : `${API_BASE_URL}/sub-option-answer/${targetOptionId}`;

//             console.log("Chatbot request:", endpointUrl);

//             const response = await axios.get(endpointUrl);

//             console.log("Chatbot response:", response.data);

//             if (response.status !== 200) {
//                 throw new Error("Unexpected response status");
//             }

//             const {
//                 answer,
//                 followups,
//                 nextQuestions,
//                 isFinal: responseIsFinal
//             } = extractBackendData(response.data);

//             const answerContent =
//                 answer || "Here is the information you requested.";

//             let optionsToShow = [];

//             if (followups.length > 0) {
//                 optionsToShow = followups;
//             } else if (nextQuestions.length > 0) {
//                 optionsToShow = nextQuestions;
//             } else {
//                 optionsToShow = fallbackFollowUps || [];
//             }

//             setMessages((prev) => [
//                 ...prev,
//                 {
//                     id: Date.now(),
//                     sender: "bot",
//                     text: answerContent,
//                     timestamp: getTime(),
//                 },
//             ]);

//             setDynamicOptions(optionsToShow);
//             setIsFinal(responseIsFinal);
//         } catch (error) {
//             console.error(
//                 "Database structural response retrieval error:",
//                 error
//             );
//             handleErrorFallback();
//         } finally {
//             setIsTyping(false);
//         }
//     };

//     const handleCustomChat = async (messageText) => {
//         setIsTyping(true);

//         try {
//             const response = await axios.post(`${API_BASE_URL}/chat`, {
//                 session_id: sessionId,
//                 message: messageText,
//             });

//             if (response.data && response.data.success) {
//                 const {
//                     answer,
//                     followups,
//                     nextQuestions,
//                     isFinal: responseIsFinal
//                 } = extractBackendData(response.data);

//                 setMessages((prev) => [
//                     ...prev,
//                     {
//                         id: response.data.log_id || Date.now(),
//                         sender: "bot",
//                         text:
//                             answer ||
//                             "Here is the information you requested.",
//                         timestamp: getTime(),
//                     },
//                 ]);

//                 if (
//                     followups.length > 0 ||
//                     nextQuestions.length > 0
//                 ) {
//                     setDynamicOptions(
//                         followups.length > 0
//                             ? followups
//                             : nextQuestions
//                     );
//                 } else {
//                     setDynamicOptions([]);
//                 }

//                 setIsFinal(responseIsFinal);
//             } else {
//                 throw new Error(
//                     response.data?.message || "Chat request failed"
//                 );
//             }
//         } catch (error) {
//             console.error(
//                 "Chat engine communication error:",
//                 error
//             );
//             handleErrorFallback();
//         } finally {
//             setIsTyping(false);
//         }
//     };

//     const handleFollowUpClick = (optItem) => {
//         const optId = getOptionId(optItem);
//         let remainingFollowUps;

//         if (optId !== null) {
//             remainingFollowUps = dynamicOptions.filter(
//                 (item) => getOptionId(item) !== optId
//             );
//         } else {
//             const clickedText = getOptionText(optItem);
//             remainingFollowUps = dynamicOptions.filter(
//                 (item) => getOptionText(item) !== clickedText
//             );
//         }

//         setDynamicOptions(remainingFollowUps);
//         setIsFinal(false);
//         handleOptionClick(optItem, remainingFollowUps);
//     };

//     const handleErrorFallback = () => {
//         setMessages((prev) => [
//             ...prev,
//             {
//                 id: Date.now(),
//                 sender: "bot",
//                 text:
//                     "Something went wrong. Please try again after sometime.",
//                 timestamp: getTime(),
//                 isError: true,
//             },
//         ]);

//         setDynamicOptions([]);
//         setIsFinal(false);
//         setShowNetworkError(true);
//     };

//     const handleEndChat = () => {
//         setShowEndChatModal(true);
//     };

//     const confirmEndChat = () => {
//         axios
//             .post(`${API_BASE_URL}/end-chat`, {
//                 session_id: sessionId,
//             })
//             .catch((error) =>
//                 console.error(
//                     "Clean session termination failed:",
//                     error
//                 )
//             );

//         setShowEndChatModal(false);
//         localStorage.removeItem("chatbot_messages");
//         localStorage.removeItem("chatbot_dynamicOptions");
//         localStorage.removeItem("chatbot_isFinal");

//         setDynamicOptions([]);
//         setSavedFollowUps([]);
//         setIsFinal(false);
//         setShowCourseSuggestionForm(false);
//         setCourseSuggestion("");
//         setScreen("welcome");
//     };

//     const handleRetryNetwork = () => {
//         setShowNetworkError(false);
//     };

//     const handleBackToWelcome = () => {
//         setDynamicOptions([]);
//         setSavedFollowUps([]);
//         setIsFinal(false);
//         setPendingMessage("");
//         setShowCourseSuggestionForm(false);
//         setCourseSuggestion("");

//         localStorage.removeItem("chatbot_messages");
//         localStorage.removeItem("chatbot_dynamicOptions");
//         localStorage.removeItem("chatbot_isFinal");

//         setScreen("welcome");
//     };

//     useEffect(() => {
//         if (pendingMessage && !pendingProcessedRef.current) {
//             pendingProcessedRef.current = true;
//             const messageToProcess = pendingMessage;

//             setDynamicOptions([]);
//             setIsFinal(false);
//             setPendingMessage("");
//             handleOptionClick(messageToProcess);
//         }

//         if (!pendingMessage) {
//             pendingProcessedRef.current = false;
//         }
//     }, [pendingMessage]);

//     useEffect(() => {
//         try {
//             localStorage.setItem(
//                 "chatbot_messages",
//                 JSON.stringify(messages)
//             );
//         } catch (error) {
//             console.error(
//                 "Could not save messages",
//                 error
//             );
//         }
//     }, [messages]);

//     useEffect(() => {
//         if (chatBodyRef.current) {
//             chatBodyRef.current.scrollTop =
//                 chatBodyRef.current.scrollHeight;
//         }
//     }, [
//         messages,
//         isTyping,
//         dynamicOptions,
//         showCourseSuggestionForm
//     ]);

//     const handleSendMessage = () => {
//         if (!inputMessage.trim()) {
//             return;
//         }

//         const userText = inputMessage.trim();

//         setMessages((prev) => [
//             ...prev,
//             {
//                 id: Date.now(),
//                 sender: "user",
//                 text: userText,
//                 timestamp: getTime(),
//             },
//         ]);

//         setInputMessage("");
//         setDynamicOptions([]);
//         setIsFinal(false);
//         handleCustomChat(userText);
//     };

//     const hasDynamicOptions = dynamicOptions.length > 0;
//     const showBackToWelcome =
//         isFinal &&
//         !isTyping &&
//         !hasDynamicOptions &&
//         !showCourseSuggestionForm;

//     return (
//         <div className="chat-screen-container">
//             <div className="chat-header">
//                 <div className="chat-header-left">
//                     <div className="chat-avatar-wrapper">
//                         <img
//                             src={botImage}
//                             alt="Bot"
//                             className="chat-avatar-img"
//                         />
//                     </div>
//                     <div>
//                         <h4 className="chat-title">
//                             IntelliBot
//                         </h4>
//                         <div className="chat-status">
//                             Online
//                         </div>
//                     </div>
//                 </div>
//                 <button
//                     className="end-chat-btn"
//                     onClick={handleEndChat}
//                 >
//                     End Chat
//                 </button>
//             </div>

//             <div
//                 className="chat-body"
//                 ref={chatBodyRef}
//             >
//                 <div className="chat-messages">
//                     {messages.map((message, idx) => {
//                         if (message.sender === "user") {
//                             return (
//                                 <div
//                                     key={message.id}
//                                     className="message user-message"
//                                 >
//                                     <div className="message-text">
//                                         {message.text}
//                                     </div>
//                                     <div className="message-time">
//                                         {message.timestamp}
//                                     </div>
//                                 </div>
//                             );
//                         }

//                         const isLatestBotMessage =
//                             idx === messages.length - 1;
//                         const showCurrentFollowUps =
//                             isLatestBotMessage && hasDynamicOptions;

//                         return (
//                             <React.Fragment key={message.id}>
//                                 <div
//                                     className={`message bot-message ${
//                                         message.isError
//                                             ? "error-bubble"
//                                             : ""
//                                     }`}
//                                 >
//                                     <div className="bot-avatar-small">
//                                         <img
//                                             src={botImage}
//                                             alt="Bot"
//                                             className="bot-avatar-img"
//                                         />
//                                     </div>
//                                     <div className="bot-message-content">
//                                         <div className="message-text">
//                                             {renderMessageContent(
//                                                 message.text
//                                             )}
//                                         </div>
//                                         <div className="message-footer">
//                                             <div className="message-time">
//                                                 {message.timestamp}
//                                             </div>
//                                             {message.isError && (
//                                                 <button
//                                                     className="inline-retry-btn"
//                                                     onClick={() =>
//                                                         setShowNetworkError(true)
//                                                     }
//                                                 >
//                                                     Retry
//                                                 </button>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {showCurrentFollowUps && (
//                                     <div
//                                         className="followup-container-outer"
//                                         style={{
//                                             margin: "6px 0 12px 40px",
//                                             display: "flex",
//                                             flexDirection: "column",
//                                             gap: "6px",
//                                             maxWidth: "80%"
//                                         }}
//                                     >
//                                         {dynamicOptions.map((opt) => {
//                                             const buttonText =
//                                                 getOptionText(opt);

//                                             if (!buttonText) {
//                                                 return null;
//                                             }

//                                             return (
//                                                 <button
//                                                     key={
//                                                         getOptionId(opt) ||
//                                                         buttonText
//                                                     }
//                                                     className="option-button followup-chip"
//                                                     style={{
//                                                         fontSize: "11px",
//                                                         padding: "8px 14px",
//                                                         borderRadius: "12px",
//                                                         background: "#f0f2f5",
//                                                         color: "#333",
//                                                         border: "1px solid #e4e6eb",
//                                                         textAlign: "left",
//                                                         cursor: "pointer",
//                                                         transition: "background 0.2s"
//                                                     }}
//                                                     onClick={() =>
//                                                         handleFollowUpClick(opt)
//                                                     }
//                                                 >
//                                                     {buttonText}
//                                                 </button>
//                                             );
//                                         })}
//                                     </div>
//                                 )}
//                             </React.Fragment>
//                         );
//                     })}

//                     {showCourseSuggestionForm && !isTyping && (
//                         <div className="course-suggestion-form-wrapper">
//                             <div className="course-suggestion-form">
//                                 <label
//                                     htmlFor="course-suggestion"
//                                     className="course-suggestion-label"
//                                 >
//                                     Preferred Course Name
//                                 </label>
//                                 <input
//                                     id="course-suggestion"
//                                     type="text"
//                                     value={courseSuggestion}
//                                     onChange={(e) => {
//                                         const value = e.target.value.slice(
//                                             0,
//                                             150
//                                         );
//                                         setCourseSuggestion(value);
//                                     }}
//                                     onKeyDown={(e) => {
//                                         if (e.key === "Enter") {
//                                             e.preventDefault();
//                                             if (
//                                                 courseSuggestion.trim() &&
//                                                 !isSubmittingSuggestion
//                                             ) {
//                                                 handleCourseSuggestionSubmit();
//                                             }
//                                         }
//                                     }}
//                                     placeholder="Enter your preferred course name..."
//                                     maxLength={150}
//                                     disabled={isSubmittingSuggestion}
//                                     className="course-suggestion-input"
//                                 />
//                                 <div className="course-suggestion-footer">
//                                     <span className="course-suggestion-counter">
//                                         {courseSuggestion.length}/150
//                                     </span>
//                                     <button
//                                         type="button"
//                                         className="course-suggestion-submit"
//                                         disabled={
//                                             !courseSuggestion.trim() ||
//                                             isSubmittingSuggestion
//                                         }
//                                         onClick={
//                                             handleCourseSuggestionSubmit
//                                         }
//                                     >
//                                         {isSubmittingSuggestion
//                                             ? "Submitting..."
//                                             : "Submit"}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     )}

//                     {isTyping && (
//                         <div className="message bot-message">
//                             <div className="bot-avatar-small">
//                                 <img
//                                     src={botImage}
//                                     alt="Bot"
//                                     className="bot-avatar-img"
//                                 />
//                             </div>
//                             <div className="bot-message-content">
//                                 <div className="typing-indicator">
//                                     <span></span>
//                                     <span></span>
//                                     <span></span>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             </div>

//             {showBackToWelcome && (
//                 <div className="chat-navigation-footer">
//                     <button
//                         type="button"
//                         className="back-to-welcome-btn"
//                         onClick={handleBackToWelcome}
//                     >
//                         Back to Main menu
//                     </button>
//                 </div>
//             )}

//             <NetworkErrorModal
//                 isOpen={showNetworkError}
//                 onRetry={handleRetryNetwork}
//                 onClose={() => setShowNetworkError(false)}
//             />

//             <EndChatModal
//                 isOpen={showEndChatModal}
//                 onClose={() => setShowEndChatModal(false)}
//                 onEndChat={confirmEndChat}
//             />
//         </div>
//     );
// };

// export default ChatScreen;


import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import botImage from "../../assets/images/chatbot_icon.png";
import NetworkErrorModal from "./NetworkErrorModal";
import EndChatModal from "./EndChatModal";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getTime = () => {
    return new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    });
};

const getOptionText = (optionItem) => {
    if (typeof optionItem === "string") {
        return optionItem;
    }

    return (
        optionItem?.option_name ||
        optionItem?.question ||
        optionItem?.title ||
        optionItem?.option_text ||
        ""
    );
};

const getOptionId = (optionItem) => {
    if (!optionItem || typeof optionItem === "string") {
        return null;
    }

    return (
        optionItem.content_id ||
        optionItem.option_id ||
        optionItem.faq_id ||
        optionItem.id ||
        null
    );
};

const renderInlineContent = (text, lineIndex) => {
    if (!text) {
        return null;
    }

    const combinedRegex =
        /(\*\*([^*]+)\*\*)|(\[([^\]]+)\]\((https?:\/\/[^\s)]+)\))|(https?:\/\/[^\s<]+)|([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})|(\+?\d[\d\s().-]{7,}\d)/g;

    const parts = [];
    let lastIndex = 0;
    let match;
    let partIndex = 0;

    while ((match = combinedRegex.exec(text)) !== null) {
        if (match.index > lastIndex) {
            parts.push(
                <React.Fragment
                    key={`text-${lineIndex}-${partIndex++}`}
                >
                    {text.substring(
                        lastIndex,
                        match.index
                    )}
                </React.Fragment>
            );
        }

        if (match[1]) {
            parts.push(
                <strong
                    key={`bold-${lineIndex}-${partIndex++}`}
                >
                    {match[2]}
                </strong>
            );
        } else if (match[3]) {
            parts.push(
                <a
                    key={`markdown-link-${lineIndex}-${partIndex++}`}
                    href={match[5]}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="chat-content-link"
                >
                    {match[4]}
                </a>
            );
        } else if (match[6]) {
            const rawUrl = match[6];
            const trailingMatch =
                rawUrl.match(/[.,!?;:]+$/);

            const cleanUrl =
                trailingMatch
                    ? rawUrl.substring(
                        0,
                        rawUrl.length -
                        trailingMatch[0].length
                    )
                    : rawUrl;

            const trailingText =
                trailingMatch
                    ? trailingMatch[0]
                    : "";

            parts.push(
                <a
                    key={`url-${lineIndex}-${partIndex++}`}
                    href={cleanUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="chat-content-link"
                >
                    {cleanUrl}
                </a>
            );

            if (trailingText) {
                parts.push(
                    <React.Fragment
                        key={`punctuation-${lineIndex}-${partIndex++}`}
                    >
                        {trailingText}
                    </React.Fragment>
                );
            }
        } else if (match[7]) {
            const emailAddress = match[7];

            parts.push(
                <a
                    key={`email-${lineIndex}-${partIndex++}`}
                    href={`mailto:${emailAddress}`}
                    className="chat-content-link chat-email-link"
                >
                    {emailAddress}
                </a>
            );
        } else if (match[8]) {
            const phoneNumber = match[8];
            const cleanPhoneNumber =
                phoneNumber.replace(
                    /[\s().-]/g,
                    ""
                );

            parts.push(
                <a
                    key={`phone-${lineIndex}-${partIndex++}`}
                    href={`tel:${cleanPhoneNumber}`}
                    className="chat-content-link chat-phone-link"
                >
                    {phoneNumber}
                </a>
            );
        }

        lastIndex = combinedRegex.lastIndex;
    }

    if (lastIndex < text.length) {
        parts.push(
            <React.Fragment
                key={`remaining-${lineIndex}-${partIndex++}`}
            >
                {text.substring(lastIndex)}
            </React.Fragment>
        );
    }

    if (parts.length === 0) {
        return text;
    }

    return parts;
};

const renderMessageContent = (text) => {
    if (!text) {
        return null;
    }

    const lines = String(text).split(/\r?\n/);

    return (
        <div className="chat-message-content-rendered">
            {lines.map((line, index) => {
                const trimmedLine = line.trim();

                if (!trimmedLine) {
                    return (
                        <div
                            key={`empty-${index}`}
                            className="chat-content-empty-line"
                        />
                    );
                }

                if (
                    trimmedLine.startsWith("* ") ||
                    trimmedLine.startsWith("- ")
                ) {
                    const bulletText =
                        trimmedLine
                            .substring(2)
                            .trim();

                    return (
                        <div
                            key={`bullet-${index}`}
                            className="chat-content-bullet"
                        >
                            <span className="chat-bullet-dot">
                                •
                            </span>
                            <span>
                                {renderInlineContent(
                                    bulletText,
                                    index
                                )}
                            </span>
                        </div>
                    );
                }

                return (
                    <div
                        key={`line-${index}`}
                        className="chat-content-line"
                    >
                        {renderInlineContent(
                            line,
                            index
                        )}
                    </div>
                );
            })}
        </div>
    );
};

const ChatScreen = ({
    onClose,
    user,
    setScreen,
    pendingMessage,
    setPendingMessage
}) => {
    const [sessionId] = useState(() => {
        return user?.email
            ? `session_${btoa(user.email).replace(/=/g, "")}`
            : `session_${Date.now()}`;
    });

    const [messages, setMessages] = useState(() => {
        try {
            const savedMessages =
                localStorage.getItem(
                    "chatbot_messages"
                );

            if (savedMessages) {
                return JSON.parse(
                    savedMessages
                );
            }
        } catch (error) {
            console.error(
                "Could not parse saved messages",
                error
            );
        }

        return [
            {
                id: 1,
                sender: "bot",
                text: `Hello ${user?.name || "there"} 👋`,
                timestamp: getTime(),
            },
            {
                id: 2,
                sender: "bot",
                text: "How can I help you today?",
                timestamp: getTime(),
            },
        ];
    });

    const [inputMessage, setInputMessage] = useState("");
    const [isTyping, setIsTyping] = useState(false);

    const [dynamicOptions, setDynamicOptions] = useState(() => {
        try {
            const saved =
                localStorage.getItem(
                    "chatbot_dynamicOptions"
                );

            if (saved) {
                return JSON.parse(saved);
            }
        } catch (error) {
            console.error(
                "Could not parse dynamic options",
                error
            );
        }

        return [];
    });

    const [isFinal, setIsFinal] = useState(() => {
        try {
            return (
                localStorage.getItem(
                    "chatbot_isFinal"
                ) === "true"
            );
        } catch (error) {
            return false;
        }
    });

    const [showNetworkError, setShowNetworkError] = useState(false);
    const [showEndChatModal, setShowEndChatModal] = useState(false);
    const [courseSuggestion, setCourseSuggestion] = useState("");
    const [isSubmittingSuggestion, setIsSubmittingSuggestion] = useState(false);
    const [showCourseSuggestionForm, setShowCourseSuggestionForm] = useState(false);

    const [savedFollowUps, setSavedFollowUps] = useState([]);

    const chatBodyRef = useRef(null);
    const pendingProcessedRef = useRef(false);

    useEffect(() => {
        try {
            localStorage.setItem(
                "chatbot_dynamicOptions",
                JSON.stringify(dynamicOptions)
            );
        } catch (error) {
            console.error(
                "Could not save dynamic options",
                error
            );
        }
    }, [dynamicOptions]);

    useEffect(() => {
        try {
            localStorage.setItem(
                "chatbot_isFinal",
                String(isFinal)
            );
        } catch (error) {
            console.error(
                "Could not save final state",
                error
            );
        }
    }, [isFinal]);

    const extractBackendData = (responseData) => {
        const data = responseData?.data || {};

        const answer =
            responseData?.answer ??
            data?.answer ??
            data?.content ??
            responseData?.content ??
            "";

        const followups =
            Array.isArray(responseData?.followups)
                ? responseData.followups
                : Array.isArray(data?.followups)
                    ? data.followups
                    : [];

        const nextQuestions =
            Array.isArray(responseData?.next_questions)
                ? responseData.next_questions
                : Array.isArray(data?.next_questions)
                    ? data.next_questions
                    : [];

        const final =
            responseData?.is_final === true ||
            data?.is_final === true;

        return {
            answer,
            followups,
            nextQuestions,
            isFinal: final,
        };
    };

    const handleCourseSuggestionSubmit = async () => {
        const courseName = courseSuggestion.trim();

        if (!courseName) {
            return;
        }

        if (courseName.length > 150) {
            return;
        }

        setIsSubmittingSuggestion(true);

        setMessages((prev) => [
            ...prev,
            {
                id: Date.now(),
                sender: "user",
                text: courseName,
                timestamp: getTime(),
            },
        ]);

        setShowCourseSuggestionForm(false);
        setCourseSuggestion("");

        try {
            const response = await axios.post(
                `${API_BASE_URL}/suggest-course`,
                {
                    suggested_course: courseName,
                    session_id: sessionId,
                    created_by_ip: "chatbot-web",
                }
            );

            console.log(
                "Course suggestion response:",
                response.data
            );

            const {
                answer,
                followups,
                nextQuestions,
                isFinal: responseIsFinal
            } = extractBackendData(response.data);

            setMessages((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    sender: "bot",
                    text:
                        answer ||
                        "Thank you for your valuable suggestion! We appreciate your feedback.",
                    timestamp: getTime(),
                },
            ]);

            if (followups.length > 0 || nextQuestions.length > 0) {
                setDynamicOptions(
                    followups.length > 0
                        ? followups
                        : nextQuestions
                );
            } else if (savedFollowUps.length > 0) {
                setDynamicOptions(savedFollowUps);
            } else {
                setDynamicOptions([]);
            }

            setSavedFollowUps([]);
            setIsFinal(responseIsFinal);
        } catch (error) {
            console.error(
                "Course suggestion submission error:",
                error
            );

            setMessages((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    sender: "bot",
                    text:
                        error?.response?.data?.detail ||
                        "We could not submit your course suggestion right now. Please try again later.",
                    timestamp: getTime(),
                    isError: true,
                },
            ]);

            if (savedFollowUps.length > 0) {
                setDynamicOptions(savedFollowUps);
            } else {
                setDynamicOptions([]);
            }

            setSavedFollowUps([]);
            setIsFinal(false);
        } finally {
            setIsSubmittingSuggestion(false);
        }
    };

    const handleOptionClick = async (
        optionItem,
        fallbackFollowUps = []
    ) => {
        const optionText = getOptionText(optionItem);
        const targetOptionId = getOptionId(optionItem);

        if (!optionText) {
            return;
        }

        if (
            Number(targetOptionId) === 9 ||
            optionText === "Suggest a New Course"
        ) {
            setSavedFollowUps(fallbackFollowUps.length > 0 ? fallbackFollowUps : dynamicOptions);

            setMessages((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    sender: "user",
                    text: optionText,
                    timestamp: getTime(),
                },
            ]);

            setDynamicOptions([]);
            setIsFinal(false);
            setIsTyping(true);

            setTimeout(() => {
                setMessages((prev) => [
                    ...prev,
                    {
                        id: Date.now(),
                        sender: "bot",
                        text:
                            `Could not find the course you were looking for?\n\nInterested in a course that is not listed? Let us know!\n\nStay tuned with us for upcoming courses. We are continuously expanding our course catalog based on industry trends and learner demand.\n\nPlease enter the course you would like SwiftIntelli to offer.`,
                        timestamp: getTime(),
                    },
                ]);

                setShowCourseSuggestionForm(true);
                setIsTyping(false);
            }, 400);

            return;
        }

        setMessages((prev) => {
            const alreadyPushed = prev.some(
                (message) =>
                    message.sender === "user" &&
                    message.text === optionText &&
                    Date.now() - message.id < 100
            );

            if (alreadyPushed) {
                return prev;
            }

            return [
                ...prev,
                {
                    id: Date.now(),
                    sender: "user",
                    text: optionText,
                    timestamp: getTime(),
                },
            ];
        });

        if (optionText === "Others...") {
            setIsFinal(false);
            setDynamicOptions([]);
            setIsTyping(true);

            setTimeout(() => {
                setMessages((prev) => [
                    ...prev,
                    {
                        id: Date.now(),
                        sender: "bot",
                        text: "Please type your specific query below!",
                        timestamp: getTime(),
                    },
                ]);

                setIsTyping(false);
            }, 400);

            return;
        }

        if (!targetOptionId) {
            await handleCustomChat(optionText);
            return;
        }

        setIsTyping(true);

        try {
            const isFaq =
                optionItem?.question !== undefined ||
                optionItem?.title !== undefined ||
                optionItem?.faq_id !== undefined ||
                optionItem?.content_id !== undefined;

            const endpointUrl = isFaq
                ? `${API_BASE_URL}/faq-answer/${targetOptionId}`
                : `${API_BASE_URL}/sub-option-answer/${targetOptionId}`;

            console.log("Chatbot request:", endpointUrl);

            const response = await axios.get(endpointUrl);

            console.log("Chatbot response:", response.data);

            if (response.status !== 200) {
                throw new Error("Unexpected response status");
            }

            const {
                answer,
                followups,
                nextQuestions,
                isFinal: responseIsFinal
            } = extractBackendData(response.data);

            const answerContent =
                answer || "Here is the information you requested.";

            let optionsToShow = [];

            if (followups.length > 0) {
                optionsToShow = followups;
            } else if (nextQuestions.length > 0) {
                optionsToShow = nextQuestions;
            } else {
                optionsToShow = fallbackFollowUps || [];
            }

            setMessages((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    sender: "bot",
                    text: answerContent,
                    timestamp: getTime(),
                },
            ]);

            setDynamicOptions(optionsToShow);
            setIsFinal(responseIsFinal);
        } catch (error) {
            console.error(
                "Database structural response retrieval error:",
                error
            );
            handleErrorFallback();
        } finally {
            setIsTyping(false);
        }
    };

    const handleCustomChat = async (messageText) => {
        setIsTyping(true);

        try {
            const response = await axios.post(`${API_BASE_URL}/chat`, {
                session_id: sessionId,
                message: messageText,
            });

            if (response.data && response.data.success) {
                const {
                    answer,
                    followups,
                    nextQuestions,
                    isFinal: responseIsFinal
                } = extractBackendData(response.data);

                setMessages((prev) => [
                    ...prev,
                    {
                        id: response.data.log_id || Date.now(),
                        sender: "bot",
                        text:
                            answer ||
                            "Here is the information you requested.",
                        timestamp: getTime(),
                    },
                ]);

                if (
                    followups.length > 0 ||
                    nextQuestions.length > 0
                ) {
                    setDynamicOptions(
                        followups.length > 0
                            ? followups
                            : nextQuestions
                    );
                } else {
                    setDynamicOptions([]);
                }

                setIsFinal(responseIsFinal);
            } else {
                throw new Error(
                    response.data?.message || "Chat request failed"
                );
            }
        } catch (error) {
            console.error(
                "Chat engine communication error:",
                error
            );
            handleErrorFallback();
        } finally {
            setIsTyping(false);
        }
    };

    const handleFollowUpClick = (optItem) => {
        const optId = getOptionId(optItem);
        let remainingFollowUps;

        if (optId !== null) {
            remainingFollowUps = dynamicOptions.filter(
                (item) => getOptionId(item) !== optId
            );
        } else {
            const clickedText = getOptionText(optItem);
            remainingFollowUps = dynamicOptions.filter(
                (item) => getOptionText(item) !== clickedText
            );
        }

        setDynamicOptions(remainingFollowUps);
        setIsFinal(false);
        handleOptionClick(optItem, remainingFollowUps);
    };

    const handleErrorFallback = () => {
        setMessages((prev) => [
            ...prev,
            {
                id: Date.now(),
                sender: "bot",
                text:
                    "Something went wrong. Please try again after sometime.",
                timestamp: getTime(),
                isError: true,
            },
        ]);

        setDynamicOptions([]);
        setIsFinal(false);
        setShowNetworkError(true);
    };

    const handleEndChat = () => {
        setShowEndChatModal(true);
    };

    const confirmEndChat = () => {
        axios
            .post(`${API_BASE_URL}/end-chat`, {
                session_id: sessionId,
            })
            .catch((error) =>
                console.error(
                    "Clean session termination failed:",
                    error
                )
            );

        setShowEndChatModal(false);
        localStorage.removeItem("chatbot_messages");
        localStorage.removeItem("chatbot_dynamicOptions");
        localStorage.removeItem("chatbot_isFinal");

        setDynamicOptions([]);
        setSavedFollowUps([]);
        setIsFinal(false);
        setShowCourseSuggestionForm(false);
        setCourseSuggestion("");
        setScreen("welcome");
    };

    const handleRetryNetwork = () => {
        setShowNetworkError(false);
    };

    const handleBackToWelcome = () => {
        setDynamicOptions([]);
        setSavedFollowUps([]);
        setIsFinal(false);
        setPendingMessage("");
        setShowCourseSuggestionForm(false);
        setCourseSuggestion("");

        localStorage.removeItem("chatbot_messages");
        localStorage.removeItem("chatbot_dynamicOptions");
        localStorage.removeItem("chatbot_isFinal");

        setScreen("welcome");
    };

    useEffect(() => {
        if (pendingMessage && !pendingProcessedRef.current) {
            pendingProcessedRef.current = true;
            const messageToProcess = pendingMessage;

            setDynamicOptions([]);
            setIsFinal(false);
            setPendingMessage("");
            handleOptionClick(messageToProcess);
        }

        if (!pendingMessage) {
            pendingProcessedRef.current = false;
        }
    }, [pendingMessage]);

    useEffect(() => {
        try {
            localStorage.setItem(
                "chatbot_messages",
                JSON.stringify(messages)
            );
        } catch (error) {
            console.error(
                "Could not save messages",
                error
            );
        }
    }, [messages]);

    useEffect(() => {
        if (chatBodyRef.current) {
            chatBodyRef.current.scrollTop =
                chatBodyRef.current.scrollHeight;
        }
    }, [
        messages,
        isTyping,
        dynamicOptions,
        showCourseSuggestionForm
    ]);

    const handleSendMessage = () => {
        if (!inputMessage.trim()) {
            return;
        }

        const userText = inputMessage.trim();

        setMessages((prev) => [
            ...prev,
            {
                id: Date.now(),
                sender: "user",
                text: userText,
                timestamp: getTime(),
            },
        ]);

        setInputMessage("");
        setDynamicOptions([]);
        setIsFinal(false);
        handleCustomChat(userText);
    };

    const hasDynamicOptions = dynamicOptions.length > 0;
    const showBackToWelcome =
        isFinal &&
        !isTyping &&
        !hasDynamicOptions &&
        !showCourseSuggestionForm;

    return (
        <div className="chat-screen-container">
            <div className="chat-header">
                <div className="chat-header-left">
                    <div className="chat-avatar-wrapper">
                        <img
                            src={botImage}
                            alt="Bot"
                            className="chat-avatar-img"
                        />
                    </div>
                    <div>
                        <h4 className="chat-title">
                            IntelliBot
                        </h4>
                        <div className="chat-status">
                            Online
                        </div>
                    </div>
                </div>
                <button
                    className="end-chat-btn"
                    onClick={handleEndChat}
                >
                    End Chat
                </button>
            </div>

            <div
                className="chat-body"
                ref={chatBodyRef}
            >
                <div className="chat-messages">
                    {messages.map((message, idx) => {
                        if (message.sender === "user") {
                            return (
                                <div
                                    key={message.id}
                                    className="message user-message"
                                >
                                    <div className="message-text">
                                        {message.text}
                                    </div>
                                    <div className="message-time">
                                        {message.timestamp}
                                    </div>
                                </div>
                            );
                        }

                        const isLatestBotMessage =
                            idx === messages.length - 1;
                        const showCurrentFollowUps =
                            isLatestBotMessage && hasDynamicOptions;

                        return (
                            <React.Fragment key={message.id}>
                                <div
                                    className={`message bot-message ${
                                        message.isError
                                            ? "error-bubble"
                                            : ""
                                    }`}
                                >
                                    <div className="bot-avatar-small">
                                        <img
                                            src={botImage}
                                            alt="Bot"
                                            className="bot-avatar-img"
                                        />
                                    </div>
                                    <div className="bot-message-content">
                                        <div className="message-text">
                                            {renderMessageContent(
                                                message.text
                                            )}
                                        </div>
                                        <div className="message-footer">
                                            <div className="message-time">
                                                {message.timestamp}
                                            </div>
                                            {message.isError && (
                                                <button
                                                    className="inline-retry-btn"
                                                    onClick={() =>
                                                        setShowNetworkError(true)
                                                    }
                                                >
                                                    Retry
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {showCurrentFollowUps && (
                                    <div
                                        className="followup-container-outer"
                                        style={{
                                            margin: "6px 0 12px 40px",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "6px",
                                            maxWidth: "80%"
                                        }}
                                    >
                                        {dynamicOptions.map((opt) => {
                                            const buttonText =
                                                getOptionText(opt);

                                            if (!buttonText) {
                                                return null;
                                            }

                                            return (
                                                <button
                                                    key={
                                                        getOptionId(opt) ||
                                                        buttonText
                                                    }
                                                    className="option-button followup-chip"
                                                    style={{
                                                        fontSize: "11px",
                                                        padding: "8px 14px",
                                                        borderRadius: "12px",
                                                        background: "#f0f2f5",
                                                        color: "#333",
                                                        border: "1px solid #e4e6eb",
                                                        textAlign: "left",
                                                        cursor: "pointer",
                                                        transition: "all 0.2s ease",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "8px"
                                                    }}
                                                    onClick={() =>
                                                        handleFollowUpClick(opt)
                                                    }
                                                >
                                                <svg
                                                    width="12"
                                                    height="12"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    style={{ flexShrink: 0, opacity: 0.7 }}
                                                >
                                                    <polyline points="15 14 20 9 15 4" />
                                                    <path d="M4 20v-7a4 4 0 0 1 4-4h12" />
                                                </svg>
                                                    <span>{buttonText}</span>
                                                </button>
                                            );
                                        })}
                                    </div>
                                )}
                            </React.Fragment>
                        );
                    })}

                    {showCourseSuggestionForm && !isTyping && (
                        <div className="course-suggestion-form-wrapper">
                            <div className="course-suggestion-form">
                                <label
                                    htmlFor="course-suggestion"
                                    className="course-suggestion-label"
                                >
                                    Preferred Course Name
                                </label>
                                <input
                                    id="course-suggestion"
                                    type="text"
                                    value={courseSuggestion}
                                    onChange={(e) => {
                                        const value = e.target.value.slice(
                                            0,
                                            150
                                        );
                                        setCourseSuggestion(value);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            if (
                                                courseSuggestion.trim() &&
                                                !isSubmittingSuggestion
                                            ) {
                                                handleCourseSuggestionSubmit();
                                            }
                                        }
                                    }}
                                    placeholder="Enter your preferred course name..."
                                    maxLength={150}
                                    disabled={isSubmittingSuggestion}
                                    className="course-suggestion-input"
                                />
                                <div className="course-suggestion-footer">
                                    <span className="course-suggestion-counter">
                                        {courseSuggestion.length}/150
                                    </span>
                                    <button
                                        type="button"
                                        className="course-suggestion-submit"
                                        disabled={
                                            !courseSuggestion.trim() ||
                                            isSubmittingSuggestion
                                        }
                                        onClick={
                                            handleCourseSuggestionSubmit
                                        }
                                    >
                                        {isSubmittingSuggestion
                                            ? "Submitting..."
                                            : "Submit"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {isTyping && (
                        <div className="message bot-message">
                            <div className="bot-avatar-small">
                                <img
                                    src={botImage}
                                    alt="Bot"
                                    className="bot-avatar-img"
                                />
                            </div>
                            <div className="bot-message-content">
                                <div className="typing-indicator">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {showBackToWelcome && (
                <div className="chat-navigation-footer">
                    <button
                        type="button"
                        className="back-to-welcome-btn"
                        onClick={handleBackToWelcome}
                    >
                        Back to Main menu
                    </button>
                </div>
            )}

            <NetworkErrorModal
                isOpen={showNetworkError}
                onRetry={handleRetryNetwork}
                onClose={() => setShowNetworkError(false)}
            />

            <EndChatModal
                isOpen={showEndChatModal}
                onClose={() => setShowEndChatModal(false)}
                onEndChat={confirmEndChat}
            />
        </div>
    );
};

export default ChatScreen;